import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  DurationString: any;
  JSON: any;
};

export type Addon = {
  __typename?: 'Addon';
  booking: Booking;
  bookingId: Scalars['String'];
  id: Scalars['String'];
  item: Item;
  itemId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type Admin = {
  __typename?: 'Admin';
  apiKeys: Array<ApiKey>;
  email: Scalars['String'];
  id: Scalars['String'];
  roles: Array<Role>;
  shops: Array<Shop>;
};

export type Agreement = {
  __typename?: 'Agreement';
  accepted: Scalars['Boolean'];
  name: Scalars['String'];
  signature?: Maybe<Scalars['String']>;
};

export type AgreementInput = {
  accepted: Scalars['Boolean'];
  name: Scalars['String'];
  signature?: InputMaybe<Scalars['String']>;
};

export type ApiKey = {
  __typename?: 'ApiKey';
  adminId: Scalars['String'];
  createdDate: Scalars['Date'];
  expires?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  lastUsed?: Maybe<Scalars['Date']>;
  name: Scalars['String'];
  revoked: Scalars['Boolean'];
};

export type AttachmentPersonalization = {
  __typename?: 'AttachmentPersonalization';
  height?: Maybe<Scalars['Int']>;
  size: Scalars['Int'];
  width?: Maybe<Scalars['Int']>;
  x: Scalars['Int'];
  y: Scalars['Int'];
};

export type AttachmentPersonalizationInput = {
  height?: InputMaybe<Scalars['Int']>;
  size: Scalars['Int'];
  width?: InputMaybe<Scalars['Int']>;
  x: Scalars['Int'];
  y: Scalars['Int'];
};

export type Boat = {
  __typename?: 'Boat';
  activeBooking?: Maybe<Booking>;
  activeBookingId?: Maybe<Scalars['String']>;
  boatNr: Scalars['Int'];
  historyLogs: Array<HistoryLog>;
  id: Scalars['String'];
  pastBookings: Array<Booking>;
  voltage?: Maybe<Scalars['Int']>;
};

export type BoatWithMetrics = {
  __typename?: 'BoatWithMetrics';
  activeBooking?: Maybe<Booking>;
  activeBookingId?: Maybe<Scalars['String']>;
  boatNr: Scalars['Int'];
  freshness: Scalars['Float'];
  id: Scalars['String'];
  sailedToday: Scalars['Float'];
  timeInBase: Scalars['Float'];
  timeSailing: Scalars['Float'];
};

export type Booking = {
  __typename?: 'Booking';
  activeBoats: Array<Boat>;
  addons: Array<Addon>;
  boatCount: Scalars['Int'];
  cancellationPolicyId?: Maybe<Scalars['String']>;
  cancellationWarranty?: Maybe<CancellationWarranty>;
  comments: Array<Comment>;
  communicationsHistoryLogs: Array<CommunicationsHistoryLog>;
  createdDate: Scalars['Date'];
  crewSignatures: Array<CrewSignature>;
  customer: Customer;
  customerId: Scalars['String'];
  date: Scalars['Date'];
  dropoffLocation?: Maybe<DockingLocation>;
  dropoffLocationId?: Maybe<Scalars['String']>;
  duration: Scalars['Float'];
  endTime: Scalars['String'];
  externalReference?: Maybe<Scalars['String']>;
  hasItems: Scalars['Boolean'];
  historyLogs: Array<HistoryLog>;
  id: Scalars['String'];
  integration?: Maybe<Integration>;
  lang?: Maybe<SupportedLanguage>;
  modifiedDate?: Maybe<Scalars['Date']>;
  paid: Scalars['Float'];
  pastBoats: Array<Boat>;
  payments: Array<Payment>;
  pickupLocation?: Maybe<DockingLocation>;
  pickupLocationId?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  priceBreakdown: BookingPriceBreakdown;
  priceModel: PriceModel;
  priceModelId?: Maybe<Scalars['String']>;
  refundable: Scalars['Float'];
  reservation?: Maybe<Reservation>;
  reservedTimeslotExpires?: Maybe<Scalars['Date']>;
  shop: Shop;
  shopId: Scalars['String'];
  startTime: Scalars['String'];
  status: BookingStatus;
  textMessages: Array<TextMessage>;
  type?: Maybe<Scalars['String']>;
  vouchers: Array<Voucher>;
  waiverSubmissions: Array<WaiverSubmission>;
};

export enum BookingLocalization {
  CalendarHelpText = 'calendarHelpText',
  LastStepInfo = 'lastStepInfo',
  NewsletterText = 'newsletterText',
  PaymentSuccessLink = 'paymentSuccessLink',
  PaymentSuccessText = 'paymentSuccessText',
  TermsLink = 'termsLink',
  TermsText = 'termsText',
  WarrantyLink = 'warrantyLink'
}

export type BookingLocalizations = {
  __typename?: 'BookingLocalizations';
  calendarHelpText?: Maybe<Localization>;
  id: Scalars['String'];
  lastStepInfo?: Maybe<Localization>;
  modifiedDate: Scalars['Date'];
  newsletterText?: Maybe<Localization>;
  paymentSuccessLink?: Maybe<Localization>;
  paymentSuccessText?: Maybe<Localization>;
  shopId: Scalars['String'];
  termsLink?: Maybe<Localization>;
  termsText?: Maybe<Localization>;
  warrantyLink?: Maybe<Localization>;
};

export type BookingPriceBreakdown = {
  __typename?: 'BookingPriceBreakdown';
  addonsPrice: Scalars['Float'];
  addonsPriceWithDiscount: Scalars['Float'];
  boatRentalPrice: Scalars['Float'];
  boatRentalPriceWithDiscount: Scalars['Float'];
  bookingPrice: Scalars['Float'];
  bookingPriceWithDiscount: Scalars['Float'];
  cancellationWarrantyPrice: Scalars['Float'];
  donationsPrice: Scalars['Float'];
  dropoffLocationPrice: Scalars['Float'];
  pickupLocationPrice: Scalars['Float'];
  tax: Scalars['Float'];
  totalPrice: Scalars['Float'];
  voucherValueAddons: Scalars['Float'];
  voucherValueBoatRental: Scalars['Float'];
  voucherValueCombined: Scalars['Float'];
};

export enum BookingStatus {
  AwaitingPayment = 'AwaitingPayment',
  CanCheckin = 'CanCheckin',
  Cancelled = 'Cancelled',
  CheckedIn = 'CheckedIn',
  CheckingOut = 'CheckingOut',
  Completed = 'Completed',
  Expired = 'Expired',
  Reserved = 'Reserved',
  Sailing = 'Sailing',
  WaitListed = 'WaitListed'
}

export type BookingTrigger = {
  __typename?: 'BookingTrigger';
  createdDate: Scalars['Date'];
  enabled: Scalars['Boolean'];
  event: BookingTriggerEvent;
  id: Scalars['String'];
  modifiedDate: Scalars['Date'];
  name: Scalars['String'];
  offsetSeconds: Scalars['Int'];
  scheduledTextMessages: Array<ScheduledTextMessage>;
  shopId: Scalars['String'];
};

export enum BookingTriggerEvent {
  Creation = 'CREATION',
  Return = 'RETURN',
  Sailout = 'SAILOUT'
}

export type BookingTriggerInput = {
  enabled: Scalars['Boolean'];
  event: BookingTriggerEvent;
  name: Scalars['String'];
  offsetSeconds: Scalars['Int'];
};

export enum BooleanCondition {
  All = 'ALL',
  No = 'NO',
  Yes = 'YES'
}

export type BulkSendResult = {
  __typename?: 'BulkSendResult';
  notSent: Array<MessageSendFailure>;
  textMessages: Array<TextMessage>;
};

export type BusinessDay = {
  __typename?: 'BusinessDay';
  UTCClosingTime?: Maybe<Scalars['Date']>;
  UTCOpeningTime?: Maybe<Scalars['Date']>;
  businessHours: Array<BusinessHours>;
  capacity: Scalars['Float'];
  date: Scalars['Date'];
  durations: Array<BusinessDayDuration>;
  historyLogs: Array<HistoryLog>;
  priceModelId?: Maybe<Scalars['String']>;
  shopId: Scalars['String'];
};

export type BusinessDayDuration = {
  __typename?: 'BusinessDayDuration';
  durationNumber: Scalars['Float'];
  durationString: Scalars['DurationString'];
  priceHigh: Scalars['Int'];
  priceLow: Scalars['Int'];
};

export type BusinessHours = {
  __typename?: 'BusinessHours';
  UTCClosingTime: Scalars['Date'];
  UTCOpeningTime: Scalars['Date'];
  /** @deprecated use integrationBoats */
  availableToIntegrations?: Maybe<Scalars['Boolean']>;
  bookableBoats: Scalars['Int'];
  capacity?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  integrationBoats: Scalars['Int'];
  maxConcurrent: Scalars['Int'];
  minimumNoticeMinutes?: Maybe<Scalars['Int']>;
  priceModel: PriceModel;
  priceModelId?: Maybe<Scalars['String']>;
  sailTimes?: Maybe<Scalars['Int']>;
};

export type BusinessHoursInput = {
  bookableBoats: Scalars['Int'];
  integrationBoats: Scalars['Int'];
  localClosingTime: Scalars['String'];
  localOpeningTime: Scalars['String'];
  maxConcurrent: Scalars['Int'];
  minimumNoticeMinutes: Scalars['Int'];
  priceModelId: Scalars['String'];
  sailTimes: Scalars['Int'];
};

export type CancellationPolicy = {
  __typename?: 'CancellationPolicy';
  active?: Maybe<Scalars['Boolean']>;
  archived?: Maybe<Scalars['Boolean']>;
  cancellationWarranty?: Maybe<CancellationPolicyDetails>;
  default: CancellationPolicyDetails;
  id: Scalars['String'];
  name: Scalars['String'];
  options?: Maybe<CancellationPolicyOptions>;
};

export type CancellationPolicyDetails = {
  __typename?: 'CancellationPolicyDetails';
  boatCount?: Maybe<Scalars['Int']>;
  cancel?: Maybe<Scalars['Int']>;
  customerInfo?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  extrasAdd?: Maybe<Scalars['Int']>;
  extrasRemove?: Maybe<Scalars['Int']>;
  location?: Maybe<Scalars['Int']>;
  refund?: Maybe<Scalars['Int']>;
  startTime?: Maybe<Scalars['Int']>;
  voucherRefund?: Maybe<Scalars['Int']>;
};

export type CancellationPolicyOptions = {
  __typename?: 'CancellationPolicyOptions';
  warrantyHelpTextBody?: Maybe<Array<Maybe<CancellationPolicyOptionsWarrantyHelpText>>>;
  warrantyHelpTextHeading?: Maybe<Array<Maybe<CancellationPolicyOptionsWarrantyHelpText>>>;
  warrantyPurchaseCutoff?: Maybe<Scalars['Int']>;
};

export type CancellationPolicyOptionsWarrantyHelpText = {
  __typename?: 'CancellationPolicyOptionsWarrantyHelpText';
  lang?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type CancellationWarranty = {
  __typename?: 'CancellationWarranty';
  bookingId: Scalars['String'];
  id: Scalars['String'];
  price: Scalars['Int'];
};

export enum CapitalizedWeekday {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export type Comment = {
  __typename?: 'Comment';
  admin?: Maybe<Admin>;
  adminId?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  bookingId: Scalars['String'];
  date: Scalars['Date'];
  id: Scalars['String'];
  text: Scalars['String'];
};

export type CommunicationsHistoryLog = {
  __typename?: 'CommunicationsHistoryLog';
  bookingTrigger?: Maybe<BookingTrigger>;
  bookingTriggerId?: Maybe<Scalars['String']>;
  createdDate: Scalars['Date'];
  event: Scalars['String'];
  id: Scalars['String'];
  meta: Scalars['JSON'];
  scheduledTextMessage?: Maybe<ScheduledTextMessage>;
  scheduledTextMessageId?: Maybe<Scalars['String']>;
  subjectAdminId?: Maybe<Scalars['String']>;
  textMessage?: Maybe<TextMessage>;
  textMessageId?: Maybe<Scalars['String']>;
  waiverId?: Maybe<Scalars['String']>;
  waiverVersionId?: Maybe<Scalars['String']>;
  who?: Maybe<HistoryLogWho>;
};

export type CrewSignature = {
  __typename?: 'CrewSignature';
  createdDate: Scalars['Date'];
  fullName: Scalars['String'];
  id: Scalars['String'];
};

export type CrewSignatureInput = {
  fullName: Scalars['String'];
};

export type Customer = {
  __typename?: 'Customer';
  birthDate?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastname?: Maybe<Scalars['String']>;
  objectHistoryLogs: Array<HistoryLog>;
  phone?: Maybe<Scalars['String']>;
};

export type CustomerInput = {
  email?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type DeleteResult = {
  __typename?: 'DeleteResult';
  count: Scalars['Int'];
};

export type DockingLocation = {
  __typename?: 'DockingLocation';
  address: Scalars['String'];
  default: Scalars['Boolean'];
  id: Scalars['String'];
  image: DockingLocationImage;
  location: GpsCoordinates;
  minutesToBase: Scalars['Int'];
  name: Scalars['String'];
  operations: Array<DockingLocationOperation>;
  priceRange: DockingLocationPriceRange;
  shopId: Scalars['String'];
  zone: DockingLocationZone;
  zoneId: Scalars['String'];
};

export type DockingLocationImage = {
  __typename?: 'DockingLocationImage';
  alt?: Maybe<Scalars['String']>;
  src: Scalars['String'];
};

export type DockingLocationImageInput = {
  alt?: InputMaybe<Scalars['String']>;
  src: Scalars['String'];
};

export type DockingLocationInput = {
  address: Scalars['String'];
  default: Scalars['Boolean'];
  image: DockingLocationImageInput;
  location: GpsCoordinatesInput;
  minutesToBase: Scalars['Int'];
  name: Scalars['String'];
  operations: Array<DockingLocationOperation>;
  shopId: Scalars['String'];
  zoneId: Scalars['String'];
};

export enum DockingLocationOperation {
  Charge = 'charge',
  Clean = 'clean',
  Dropoff = 'dropoff',
  Pickup = 'pickup'
}

export type DockingLocationPriceRange = {
  __typename?: 'DockingLocationPriceRange';
  high: Scalars['Float'];
  low: Scalars['Float'];
};

export type DockingLocationZone = {
  __typename?: 'DockingLocationZone';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type DockingLocationZonePrice = {
  __typename?: 'DockingLocationZonePrice';
  dockingLocationZoneId: Scalars['String'];
  id: Scalars['String'];
  price: Scalars['Float'];
  priceModelId: Scalars['String'];
};

export type DockingLocationZonePriceInput = {
  dockingLocationZoneId: Scalars['String'];
  price: Scalars['Float'];
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  enabled: Scalars['Boolean'];
  featureName: FeatureName;
  id: Scalars['String'];
  shop: Shop;
};

export enum FeatureName {
  LegacyPayments = 'LEGACY_PAYMENTS',
  LocalizedTimeDisplay = 'LOCALIZED_TIME_DISPLAY',
  MobilePayments = 'MOBILE_PAYMENTS',
  SeparateGiftcardVoucherRefunds = 'SEPARATE_GIFTCARD_VOUCHER_REFUNDS',
  StrictSailout = 'STRICT_SAILOUT',
  VoucherRefund = 'VOUCHER_REFUND',
  VoucherRefundValidForExtras = 'VOUCHER_REFUND__VALID_FOR_EXTRAS'
}

export type GpsCoordinates = {
  __typename?: 'GPSCoordinates';
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type GpsCoordinatesInput = {
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type GetAdminsResult = {
  __typename?: 'GetAdminsResult';
  admins: Array<Admin>;
  total: Scalars['Int'];
};

export type GetAndCountBookingsResult = {
  __typename?: 'GetAndCountBookingsResult';
  bookings: Array<Booking>;
  total: Scalars['Int'];
};

export type GiftCard = {
  __typename?: 'GiftCard';
  campaignName?: Maybe<Scalars['String']>;
  campaigns: Array<Voucher>;
  createdDate: Scalars['Date'];
  customer: Customer;
  customerId: Scalars['String'];
  duration: Scalars['Float'];
  id: Scalars['String'];
  lang: SupportedLanguage;
  price: Scalars['Int'];
  priceBreakdown: GiftCardPriceBreakdown;
  recipient?: Maybe<GiftCardRecipient>;
  shop: Shop;
  shopId: Scalars['String'];
};

export enum GiftCardLocalization {
  Heading = 'heading',
  Instructions = 'instructions',
  NewsletterText = 'newsletterText',
  StepOneHeading = 'stepOneHeading',
  StepThreeHeading = 'stepThreeHeading',
  StepTwoHeading = 'stepTwoHeading'
}

export type GiftCardLocalizations = {
  __typename?: 'GiftCardLocalizations';
  heading?: Maybe<Localization>;
  id: Scalars['String'];
  instructions?: Maybe<Localization>;
  modifiedDate: Scalars['Date'];
  newsletterText?: Maybe<Localization>;
  shopId: Scalars['String'];
  stepOneHeading?: Maybe<Localization>;
  stepThreeHeading?: Maybe<Localization>;
  stepTwoHeading?: Maybe<Localization>;
};

export type GiftCardPriceBreakdown = {
  __typename?: 'GiftCardPriceBreakdown';
  balance: Scalars['Float'];
  campaignValue: Scalars['Float'];
  giftCardPrice: Scalars['Float'];
  giftCardValue: Scalars['Float'];
  tax: Scalars['Float'];
  totalPayment: Scalars['Float'];
  totalPrice: Scalars['Float'];
};

export type GiftCardRecipient = {
  __typename?: 'GiftCardRecipient';
  name?: Maybe<Scalars['String']>;
};

export type HistoryLog = {
  __typename?: 'HistoryLog';
  boatIds: Array<Scalars['String']>;
  boats: Array<Boat>;
  bookingId?: Maybe<Scalars['String']>;
  comment?: Maybe<Comment>;
  commentId?: Maybe<Scalars['String']>;
  createdDate: Scalars['Date'];
  event: Scalars['String'];
  id: Scalars['String'];
  meta: Scalars['JSON'];
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['String']>;
  subjectAdminId?: Maybe<Scalars['String']>;
  subjectCustomerId?: Maybe<Scalars['String']>;
  voucher?: Maybe<Voucher>;
  voucherId?: Maybe<Scalars['String']>;
  who?: Maybe<HistoryLogWho>;
};

export enum HistoryLogRelation {
  ShopId = 'shopId'
}

export type HistoryLogWho = {
  __typename?: 'HistoryLogWho';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Integration = {
  __typename?: 'Integration';
  bookings: Array<Booking>;
  cancellationPolicy?: Maybe<CancellationPolicy>;
  cancellationPolicyId?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['Date']>;
  fields: Array<IntegrationField>;
  id: Scalars['String'];
  modifiedDate?: Maybe<Scalars['Date']>;
  products: Array<IntegrationProduct>;
  service: Service;
  shop: Shop;
  shopId: Scalars['String'];
};

export type IntegrationField = {
  __typename?: 'IntegrationField';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type IntegrationFieldInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type IntegrationProduct = {
  __typename?: 'IntegrationProduct';
  duration: Scalars['DurationString'];
  id: Scalars['String'];
  integration: Integration;
  integrationId: Scalars['String'];
};

export type IntegrationProductInput = {
  duration: Scalars['DurationString'];
};

export type Item = {
  __typename?: 'Item';
  archived?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Scalars['String']>;
  days: Array<ItemDays>;
  description?: Maybe<Scalars['String']>;
  displayedOn: Array<Scalars['String']>;
  donation?: Maybe<Scalars['Boolean']>;
  duration?: Maybe<ItemDuration>;
  id: Scalars['String'];
  imagepath?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  preBook?: Maybe<Scalars['Boolean']>;
  preBookCutoff?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Int']>;
  shortDescription?: Maybe<Scalars['String']>;
  stock?: Maybe<Scalars['Int']>;
  times?: Maybe<ItemTimes>;
  useCustomPreBookCutoff?: Maybe<Scalars['Boolean']>;
};

export type ItemDays = {
  __typename?: 'ItemDays';
  available?: Maybe<Scalars['Boolean']>;
  weekday?: Maybe<Scalars['String']>;
};

export type ItemDuration = {
  __typename?: 'ItemDuration';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

export type ItemInput = {
  itemId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type ItemReservation = {
  __typename?: 'ItemReservation';
  id: Scalars['String'];
  item: Item;
  itemId: Scalars['String'];
  quantity: Scalars['Int'];
  reservationId: Scalars['String'];
};

export type ItemTimes = {
  __typename?: 'ItemTimes';
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
};

export type Localization = {
  __typename?: 'Localization';
  da?: Maybe<Scalars['String']>;
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  es?: Maybe<Scalars['String']>;
  fr?: Maybe<Scalars['String']>;
  it?: Maybe<Scalars['String']>;
  sv?: Maybe<Scalars['String']>;
};

export type LocalizationInput = {
  da?: InputMaybe<Scalars['String']>;
  de?: InputMaybe<Scalars['String']>;
  en?: InputMaybe<Scalars['String']>;
  es?: InputMaybe<Scalars['String']>;
  fr?: InputMaybe<Scalars['String']>;
  it?: InputMaybe<Scalars['String']>;
  sv?: InputMaybe<Scalars['String']>;
};

export type LocalizedMailChimpList = {
  __typename?: 'LocalizedMailChimpList';
  id: Scalars['String'];
  language: Scalars['String'];
};

export type LocalizedMailchimpListInput = {
  id: Scalars['String'];
  language: Scalars['String'];
};

export type Location = {
  __typename?: 'Location';
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type MailchimpConfig = {
  __typename?: 'MailchimpConfig';
  apiKey: Scalars['String'];
  archived?: Maybe<Scalars['Boolean']>;
  defaultListId: Scalars['String'];
  id: Scalars['String'];
  localizedLists: Array<LocalizedMailChimpList>;
  shopId: Scalars['String'];
  testListId?: Maybe<Scalars['String']>;
};

export type MailchimpConfigInput = {
  apiKey: Scalars['String'];
  defaultListId: Scalars['String'];
  localizedLists: Array<LocalizedMailchimpListInput>;
  testListId?: InputMaybe<Scalars['String']>;
};

export type Membership = {
  __typename?: 'Membership';
  customer: Customer;
  customerId: Scalars['String'];
  endDate: Scalars['Date'];
  id: Scalars['String'];
  lang: SupportedLanguage;
  plan: Plan;
  planId: Scalars['String'];
  priceBreakdown: MembershipPriceBreakdown;
  shop: Shop;
  shopId: Scalars['String'];
  startDate: Scalars['Date'];
  vouchers: Array<Voucher>;
};

export type MembershipPlanName = {
  __typename?: 'MembershipPlanName';
  da: Scalars['String'];
  en: Scalars['String'];
  sv: Scalars['String'];
};

export type MembershipPriceBreakdown = {
  __typename?: 'MembershipPriceBreakdown';
  balance: Scalars['Float'];
  membershipPrice: Scalars['Float'];
  tax: Scalars['Float'];
  totalPayment: Scalars['Float'];
  totalPrice: Scalars['Float'];
  voucherValue: Scalars['Float'];
};

export type MessageSendFailure = {
  __typename?: 'MessageSendFailure';
  entityId: Scalars['String'];
  errorMessage: Scalars['String'];
};

export type MinorSignature = {
  __typename?: 'MinorSignature';
  birthDate?: Maybe<Scalars['Date']>;
  name: Scalars['String'];
};

export type MinorSignatureInput = {
  birthDate?: InputMaybe<Scalars['Date']>;
  name: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addAdminApiKey: Admin;
  addAdminRoles: Admin;
  addAdminShopAccesses: Admin;
  addCancellationWarranty: Booking;
  addComment: Comment;
  addIntegrationProducts?: Maybe<Integration>;
  addItemToBooking: Addon;
  applyVoucherToBooking: Booking;
  archiveMailchimpConfig: MailchimpConfig;
  assignBoatsToBooking: Booking;
  cancelBooking: Booking;
  checkOutAllBookings: Scalars['Boolean'];
  confirmBookingPayment: Booking;
  confirmCreateBookingPayment: Booking;
  confirmEditBooking: Booking;
  confirmEditBookingPayment: Booking;
  createAdmin: Admin;
  createBoat: Boat;
  createBookingPaymentIntent: Scalars['String'];
  createBookingTrigger: BookingTrigger;
  createDockingLocation: DockingLocation;
  createDockingLocationZone: DockingLocationZone;
  createIntegration?: Maybe<Integration>;
  createMailchimpConfig: MailchimpConfig;
  createPayForBookingPaymentIntent: Scalars['String'];
  createPayment: Payment;
  createPriceModel: PriceModel;
  createRefund: Payment;
  createReservationPaymentIntent: Scalars['String'];
  createScheduledTextMessage: ScheduledTextMessage;
  createSendgridEmail: SendgridEmail;
  createSendgridEmailAttachment: SendgridEmailAttachment;
  createService?: Maybe<Service>;
  createWaiver: Waiver;
  createWaiverVersion: WaiverVersion;
  createWalkin: Booking;
  customerConfirmBooking: Booking;
  deleteBusinessHours?: Maybe<DeleteResult>;
  deleteComment: Scalars['Boolean'];
  deleteIntegration?: Maybe<Scalars['String']>;
  deleteSendgridEmail: Scalars['Boolean'];
  deleteSendgridEmailAttachment: Scalars['Boolean'];
  editBooking: Booking;
  editScheduledTextMessage: ScheduledTextMessage;
  editSendgridEmail: SendgridEmail;
  editSendgridEmailAttachment: SendgridEmailAttachment;
  editWaiver: Waiver;
  editWaiverVersion: WaiverVersion;
  expireBooking: Booking;
  freeUpBoats: Array<Boat>;
  initiatePaymentCreateBooking: Booking;
  initiatePaymentEditBooking: Booking;
  initiatePaymentPayForBooking: Booking;
  redeemReceiptToken: ReceiptToken;
  removeAdminRoles: Admin;
  removeAdminShopAccesses: Admin;
  removeCancellationWarranty: Booking;
  removeIntegrationProducts?: Maybe<Integration>;
  removeVoucherFromBooking: Booking;
  requestReceiptToken: ReceiptToken;
  resellerConfirmBooking: Booking;
  reserve: Booking;
  reserveTimeslot: Reservation;
  restoreComment: Comment;
  revokeApiKey: ApiKey;
  sendMultipleScheduledTextMessages: BulkSendResult;
  sendMultipleTextMessages: BulkSendResult;
  sendScheduledTextMessage: TextMessage;
  sendTextMessage: Scalars['Boolean'];
  setActiveWaiver: Waiver;
  setActiveWaiverVersion: WaiverVersion;
  setBookingAddons: Booking;
  setBookingLanguage: Booking;
  setBookingLocalization: BookingLocalizations;
  setBusinessDays?: Maybe<Scalars['Boolean']>;
  setFeatureFlag: FeatureFlag;
  setGiftCardLocalization: GiftCardLocalizations;
  setInactiveWaiver: Waiver;
  setReservationItems: Array<ItemReservation>;
  setShopConfiguration: ShopConfiguration;
  setTextMessagingSettings: TextMessagingSettings;
  setUspBannerEntries: Scalars['Int'];
  submitDockTypeWaiver: Scalars['Int'];
  submitWaiver: WaiverSubmission;
  updateBookingStatus: Booking;
  updateBookingTrigger: BookingTrigger;
  updateBusinessHours: Array<BusinessHours>;
  updateCustomer: Customer;
  updateIntegration?: Maybe<Integration>;
  updateMailchimpConfig: MailchimpConfig;
  updatePaymentIntentAmount: Scalars['Int'];
  updateService?: Maybe<Service>;
  updateTextMessageStatus: TextMessage;
};


export type MutationAddAdminApiKeyArgs = {
  adminId: Scalars['String'];
  name: Scalars['String'];
};


export type MutationAddAdminRolesArgs = {
  adminId: Scalars['String'];
  roleIds: Array<Scalars['String']>;
};


export type MutationAddAdminShopAccessesArgs = {
  adminId: Scalars['String'];
  shopIds: Array<Scalars['String']>;
};


export type MutationAddCancellationWarrantyArgs = {
  bookingId: Scalars['String'];
};


export type MutationAddCommentArgs = {
  author?: InputMaybe<Scalars['String']>;
  bookingId: Scalars['String'];
  text: Scalars['String'];
};


export type MutationAddIntegrationProductsArgs = {
  integrationId: Scalars['String'];
  products: Array<IntegrationProductInput>;
};


export type MutationAddItemToBookingArgs = {
  bookingId: Scalars['String'];
  itemId: Scalars['String'];
  quantity: Scalars['Int'];
};


export type MutationApplyVoucherToBookingArgs = {
  bookingId: Scalars['String'];
  paymentIntentId?: InputMaybe<Scalars['String']>;
  reservationId?: InputMaybe<Scalars['String']>;
  voucherCode: Scalars['String'];
};


export type MutationArchiveMailchimpConfigArgs = {
  id: Scalars['String'];
};


export type MutationAssignBoatsToBookingArgs = {
  boatIds: Array<Scalars['String']>;
  bookingId: Scalars['String'];
};


export type MutationCancelBookingArgs = {
  id: Scalars['String'];
  idempotent?: InputMaybe<Scalars['Boolean']>;
  voucherRefund?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCheckOutAllBookingsArgs = {
  shopId: Scalars['String'];
};


export type MutationConfirmBookingPaymentArgs = {
  paymentIntentId: Scalars['String'];
  shopId: Scalars['String'];
};


export type MutationConfirmCreateBookingPaymentArgs = {
  paymentIntentId: Scalars['String'];
  shopId: Scalars['String'];
};


export type MutationConfirmEditBookingArgs = {
  reservationId: Scalars['String'];
  subToNewsletter?: InputMaybe<Scalars['Boolean']>;
};


export type MutationConfirmEditBookingPaymentArgs = {
  paymentIntentId: Scalars['String'];
  shopId: Scalars['String'];
};


export type MutationCreateAdminArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  roleIds: Array<Scalars['String']>;
  shopIds: Array<Scalars['String']>;
};


export type MutationCreateBoatArgs = {
  boatNr: Scalars['Int'];
  shopId: Scalars['String'];
};


export type MutationCreateBookingPaymentIntentArgs = {
  id: Scalars['String'];
};


export type MutationCreateBookingTriggerArgs = {
  shopId: Scalars['String'];
  trigger: BookingTriggerInput;
};


export type MutationCreateDockingLocationArgs = {
  input: DockingLocationInput;
};


export type MutationCreateDockingLocationZoneArgs = {
  name: Scalars['String'];
  shopId: Scalars['String'];
};


export type MutationCreateIntegrationArgs = {
  fields: Array<IntegrationFieldInput>;
  serviceId: Scalars['String'];
  shopId: Scalars['String'];
};


export type MutationCreateMailchimpConfigArgs = {
  config: MailchimpConfigInput;
  shopId: Scalars['String'];
};


export type MutationCreatePayForBookingPaymentIntentArgs = {
  bookingId: Scalars['String'];
};


export type MutationCreatePaymentArgs = {
  amount: Scalars['Float'];
  bookingId: Scalars['String'];
  creator?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};


export type MutationCreatePriceModelArgs = {
  input: PriceModelInput;
};


export type MutationCreateRefundArgs = {
  amount: Scalars['Float'];
  bookingId: Scalars['String'];
  creator?: InputMaybe<Scalars['String']>;
  paymentId?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};


export type MutationCreateReservationPaymentIntentArgs = {
  reservationId: Scalars['String'];
};


export type MutationCreateScheduledTextMessageArgs = {
  message: ScheduledTextMessageInput;
  shopId: Scalars['String'];
};


export type MutationCreateSendgridEmailArgs = {
  attachmentIds: Array<Scalars['String']>;
  email: SendgridEmailInput;
};


export type MutationCreateSendgridEmailAttachmentArgs = {
  attachment: SendgridEmailAttachmentInput;
};


export type MutationCreateServiceArgs = {
  description: Scalars['String'];
  fields: Array<ServiceFieldInput>;
  name: Scalars['String'];
  type: ServiceType;
};


export type MutationCreateWaiverArgs = {
  active: Scalars['Boolean'];
  archived: Scalars['Boolean'];
  name: Scalars['String'];
  shopId: Scalars['String'];
  type: WaiverType;
};


export type MutationCreateWaiverVersionArgs = {
  data: WaiverVersionInput;
};


export type MutationCreateWalkinArgs = {
  boatCount: Scalars['Int'];
  customer: CustomerInput;
  date: Scalars['Date'];
  dropoffLocationId?: InputMaybe<Scalars['String']>;
  duration: Scalars['Float'];
  lang?: InputMaybe<SupportedLanguage>;
  pickupLocationId?: InputMaybe<Scalars['String']>;
  sendEmail?: InputMaybe<Scalars['Boolean']>;
  shopId: Scalars['String'];
};


export type MutationCustomerConfirmBookingArgs = {
  bookingId: Scalars['String'];
  subToNewsletter?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDeleteBusinessHoursArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationDeleteCommentArgs = {
  commentId: Scalars['String'];
};


export type MutationDeleteIntegrationArgs = {
  id: Scalars['String'];
};


export type MutationDeleteSendgridEmailArgs = {
  id: Scalars['String'];
};


export type MutationDeleteSendgridEmailAttachmentArgs = {
  id: Scalars['String'];
};


export type MutationEditBookingArgs = {
  boatCount: Scalars['Int'];
  date: Scalars['Date'];
  dropoffLocationId?: InputMaybe<Scalars['String']>;
  duration: Scalars['Float'];
  forfeitVouchers?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  pickupLocationId?: InputMaybe<Scalars['String']>;
};


export type MutationEditScheduledTextMessageArgs = {
  id: Scalars['String'];
  message: ScheduledTextMessageInput;
};


export type MutationEditSendgridEmailArgs = {
  attachmentIds: Array<Scalars['String']>;
  email: SendgridEmailInput;
  id: Scalars['String'];
};


export type MutationEditSendgridEmailAttachmentArgs = {
  attachment: SendgridEmailAttachmentInput;
  id: Scalars['String'];
};


export type MutationEditWaiverArgs = {
  id: Scalars['String'];
  waiver: WaiverInput;
};


export type MutationEditWaiverVersionArgs = {
  id: Scalars['String'];
  waiverVersion: WaiverVersionInput;
};


export type MutationExpireBookingArgs = {
  id: Scalars['String'];
};


export type MutationFreeUpBoatsArgs = {
  boatIds: Array<Scalars['String']>;
};


export type MutationInitiatePaymentCreateBookingArgs = {
  bookingId: Scalars['String'];
  clientPrice: Scalars['Int'];
  paymentIntentId: Scalars['String'];
  subscribeToNewsletter?: InputMaybe<Scalars['Boolean']>;
};


export type MutationInitiatePaymentEditBookingArgs = {
  bookingId: Scalars['String'];
  clientPrice: Scalars['Int'];
  paymentIntentId: Scalars['String'];
  reservationId: Scalars['String'];
  subscribeToNewsletter?: InputMaybe<Scalars['Boolean']>;
};


export type MutationInitiatePaymentPayForBookingArgs = {
  bookingId: Scalars['String'];
  clientPrice: Scalars['Int'];
  paymentIntentId: Scalars['String'];
  subscribeToNewsletter?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRedeemReceiptTokenArgs = {
  id: Scalars['String'];
};


export type MutationRemoveAdminRolesArgs = {
  adminId: Scalars['String'];
  roleIds: Array<Scalars['String']>;
};


export type MutationRemoveAdminShopAccessesArgs = {
  adminId: Scalars['String'];
  shopIds: Array<Scalars['String']>;
};


export type MutationRemoveCancellationWarrantyArgs = {
  bookingId: Scalars['String'];
};


export type MutationRemoveIntegrationProductsArgs = {
  integrationId: Scalars['String'];
  productIds: Array<Scalars['String']>;
};


export type MutationRemoveVoucherFromBookingArgs = {
  bookingId: Scalars['String'];
  voucherId: Scalars['String'];
};


export type MutationRequestReceiptTokenArgs = {
  entityId: Scalars['String'];
  type: ReceiptTokenType;
};


export type MutationResellerConfirmBookingArgs = {
  bookingId: Scalars['String'];
  comments?: InputMaybe<Array<Scalars['String']>>;
  commissionAmount?: InputMaybe<Scalars['Float']>;
  customerDetails: CustomerInput;
  paymentAmount: Scalars['Float'];
  paymentCreator: Scalars['String'];
  resellerReference?: InputMaybe<Scalars['String']>;
};


export type MutationReserveArgs = {
  boatCount: Scalars['Int'];
  customer: CustomerInput;
  date: Scalars['Date'];
  dropoffLocationId?: InputMaybe<Scalars['String']>;
  duration: Scalars['Float'];
  externalReference?: InputMaybe<Scalars['String']>;
  integrationId?: InputMaybe<Scalars['String']>;
  lang?: InputMaybe<SupportedLanguage>;
  pickupLocationId?: InputMaybe<Scalars['String']>;
  resellerName?: InputMaybe<Scalars['String']>;
  resellerReference?: InputMaybe<Scalars['String']>;
  shopId: Scalars['String'];
};


export type MutationReserveTimeslotArgs = {
  boatCount: Scalars['Int'];
  bookingId: Scalars['String'];
  date: Scalars['Date'];
  dropoffLocationId?: InputMaybe<Scalars['String']>;
  duration: Scalars['Float'];
  items: Array<ItemInput>;
  pickupLocationId?: InputMaybe<Scalars['String']>;
};


export type MutationRestoreCommentArgs = {
  commentId: Scalars['String'];
};


export type MutationRevokeApiKeyArgs = {
  id: Scalars['String'];
};


export type MutationSendMultipleScheduledTextMessagesArgs = {
  bookingIds: Array<Scalars['String']>;
  scheduledTextMessageId: Scalars['String'];
};


export type MutationSendMultipleTextMessagesArgs = {
  body: Scalars['String'];
  bookingIds: Array<Scalars['String']>;
};


export type MutationSendScheduledTextMessageArgs = {
  bookingId: Scalars['String'];
  recipientNumber?: InputMaybe<Scalars['String']>;
  scheduledTextMessageId: Scalars['String'];
};


export type MutationSendTextMessageArgs = {
  bookingId: Scalars['String'];
  recipientNumber: Scalars['String'];
  text: Scalars['String'];
};


export type MutationSetActiveWaiverArgs = {
  id: Scalars['String'];
};


export type MutationSetActiveWaiverVersionArgs = {
  id: Scalars['String'];
};


export type MutationSetBookingAddonsArgs = {
  bookingId: Scalars['String'];
  items: Array<ItemInput>;
};


export type MutationSetBookingLanguageArgs = {
  id: Scalars['String'];
  language: SupportedLanguage;
};


export type MutationSetBookingLocalizationArgs = {
  localization: BookingLocalization;
  shopId: Scalars['String'];
  values: LocalizationInput;
};


export type MutationSetBusinessDaysArgs = {
  businessHours: Array<BusinessHoursInput>;
  dates: Array<Scalars['Date']>;
  shopId: Scalars['String'];
};


export type MutationSetFeatureFlagArgs = {
  enabled: Scalars['Boolean'];
  featureName: FeatureName;
  shopId: Scalars['String'];
};


export type MutationSetGiftCardLocalizationArgs = {
  localization: GiftCardLocalization;
  shopId: Scalars['String'];
  values: LocalizationInput;
};


export type MutationSetInactiveWaiverArgs = {
  id: Scalars['String'];
};


export type MutationSetReservationItemsArgs = {
  items: Array<ItemInput>;
  reservationId: Scalars['String'];
};


export type MutationSetShopConfigurationArgs = {
  input: ShopConfigurationInput;
  shopId: Scalars['String'];
};


export type MutationSetTextMessagingSettingsArgs = {
  settings: TextMessagingSettingsInput;
  shopId: Scalars['String'];
};


export type MutationSetUspBannerEntriesArgs = {
  input: Array<UspBannerInput>;
  language: SupportedLanguage;
  shopId: Scalars['String'];
};


export type MutationSubmitDockTypeWaiverArgs = {
  bookingId: Scalars['String'];
  crewSignature: CrewSignatureInput;
  signatures: Array<SignatureInput>;
  waiverVersionId: Scalars['String'];
};


export type MutationSubmitWaiverArgs = {
  agreements: Array<AgreementInput>;
  bookingId: Scalars['String'];
  data: WaiverData;
  email?: InputMaybe<Scalars['String']>;
  fullName: Scalars['String'];
  minors?: InputMaybe<Array<MinorSignatureInput>>;
  waiverVersionId: Scalars['String'];
};


export type MutationUpdateBookingStatusArgs = {
  id: Scalars['String'];
  status: BookingStatus;
};


export type MutationUpdateBookingTriggerArgs = {
  id: Scalars['String'];
  trigger: BookingTriggerInput;
};


export type MutationUpdateBusinessHoursArgs = {
  ids: Array<Scalars['String']>;
  input: UpdateBusinessHoursInput;
};


export type MutationUpdateCustomerArgs = {
  id: Scalars['String'];
  input: CustomerInput;
};


export type MutationUpdateIntegrationArgs = {
  cancellationPolicyId?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Array<IntegrationFieldInput>>;
  id: Scalars['String'];
};


export type MutationUpdateMailchimpConfigArgs = {
  config: MailchimpConfigInput;
  id: Scalars['String'];
};


export type MutationUpdatePaymentIntentAmountArgs = {
  bookingId: Scalars['String'];
  paymentIntentId: Scalars['String'];
  reservationId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateServiceArgs = {
  description: Scalars['String'];
  fields: Array<ServiceFieldInput>;
  id: Scalars['String'];
  name: Scalars['String'];
  type: ServiceType;
};


export type MutationUpdateTextMessageStatusArgs = {
  messageSid: Scalars['String'];
  status: TextMessageStatus;
};

export type OldAttachment = {
  __typename?: 'OldAttachment';
  path?: Maybe<Scalars['String']>;
  personalization?: Maybe<Scalars['JSON']>;
};

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['Float'];
  booking: Booking;
  commission?: Maybe<Scalars['Float']>;
  creator?: Maybe<Scalars['String']>;
  currency: Scalars['String'];
  id: Scalars['String'];
  shopId?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Plan = {
  __typename?: 'Plan';
  id: Scalars['String'];
  name: MembershipPlanName;
};

export type PriceModel = {
  __typename?: 'PriceModel';
  archived?: Maybe<Scalars['Boolean']>;
  cancellationWarranty?: Maybe<PriceModelWarranty>;
  createdDate?: Maybe<Scalars['Date']>;
  currency: Scalars['String'];
  default: Scalars['Boolean'];
  defaultDurationBooking?: Maybe<Scalars['String']>;
  defaultDurationGiftcard?: Maybe<Scalars['String']>;
  dockingLocationZonePrices: Array<DockingLocationZonePrice>;
  durations: Array<PriceModelDuration>;
  giftcards?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  inUse?: Maybe<Scalars['Boolean']>;
  modifiedDate?: Maybe<Scalars['Date']>;
  name: Scalars['String'];
  shop?: Maybe<Shop>;
  shopId?: Maybe<Scalars['String']>;
};

export type PriceModelDuration = {
  __typename?: 'PriceModelDuration';
  duration: Scalars['DurationString'];
  giftcards: Scalars['Boolean'];
  price: Scalars['Float'];
};

export type PriceModelDurationInput = {
  duration: Scalars['DurationString'];
  giftcards: Scalars['Boolean'];
  price: Scalars['Float'];
};

export type PriceModelInput = {
  cancellationWarranty?: InputMaybe<PriceModelWarrantyInput>;
  currency: Scalars['String'];
  default?: InputMaybe<Scalars['Boolean']>;
  defaultDurationBooking?: InputMaybe<Scalars['String']>;
  defaultDurationGiftcard?: InputMaybe<Scalars['String']>;
  dockingLocationZonePrices: Array<DockingLocationZonePriceInput>;
  durations: Array<PriceModelDurationInput>;
  giftcards?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  shopId: Scalars['String'];
};

export type PriceModelWarranty = {
  __typename?: 'PriceModelWarranty';
  per?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
};

export type PriceModelWarrantyInput = {
  per: Scalars['String'];
  price: Scalars['Float'];
};

export type Query = {
  __typename?: 'Query';
  bookingApiHealth: Scalars['Boolean'];
  communicationsApiHealth: Scalars['Boolean'];
  getAdmin?: Maybe<Admin>;
  getAdmins: GetAdminsResult;
  getAndCountBookings: GetAndCountBookingsResult;
  getBoat?: Maybe<Boat>;
  getBoats: Array<Boat>;
  getBoatsWithMetrics: Array<BoatWithMetrics>;
  getBooking: Booking;
  getBookingTrigger: BookingTrigger;
  getBookingTriggers: Array<BookingTrigger>;
  getBookingTriggersByShopId: Array<BookingTrigger>;
  getBookings: Array<Booking>;
  getBookingsById: Array<Booking>;
  getBookingsByReturnTime: Array<Booking>;
  getBusinessDay?: Maybe<BusinessDay>;
  getBusinessDays: Array<BusinessDay>;
  getBusinessHours: Array<BusinessHours>;
  getCancellationPolicies: Array<CancellationPolicy>;
  getDockingLocationZonesByShopId: Array<DockingLocationZone>;
  getGiftCard: GiftCard;
  getHistoryLogs: Array<HistoryLog>;
  getIntegration?: Maybe<Integration>;
  getIntegrationProduct?: Maybe<IntegrationProduct>;
  getIntegrationProductsByBookingId: Array<IntegrationProduct>;
  getIntegrations: Array<Integration>;
  getMailchimpConfig?: Maybe<MailchimpConfig>;
  getMembership: Membership;
  getPriceModels: Array<PriceModel>;
  getReceiptToken: ReceiptToken;
  getRoles: Array<Role>;
  getScheduledTextMessage: ScheduledTextMessage;
  getScheduledTextMessages: Array<ScheduledTextMessage>;
  getSelf?: Maybe<Admin>;
  getSendgridEmail: SendgridEmail;
  getSendgridEmailAttachment: SendgridEmailAttachment;
  getSendgridEmailAttachments: Array<SendgridEmailAttachment>;
  getSendgridEmails: Array<SendgridEmail>;
  getService?: Maybe<Service>;
  getServices: Array<Service>;
  getShop?: Maybe<Shop>;
  getShopConfiguration?: Maybe<ShopConfiguration>;
  getShops: Array<Shop>;
  getSignedAttachmentUploadLink: SignedAttachmentUploadLinkResult;
  getTextMessagingSettings?: Maybe<TextMessagingSettings>;
  getTimeslots: Array<Timeslot>;
  getUspBannerEntries: Array<UspBannerEntry>;
  getVoucher: Voucher;
  getWaiver: Waiver;
  getWaiverBySlug: Waiver;
  getWaiverSubmission: WaiverSubmission;
  getWaiverVersion: WaiverVersion;
  getWaivers: Array<Waiver>;
  previewScheduledTextMessage: Scalars['String'];
  waiversApiHealth: Scalars['Boolean'];
};


export type QueryGetAdminArgs = {
  id: Scalars['String'];
};


export type QueryGetAdminsArgs = {
  roleIds?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  shopIds?: InputMaybe<Array<Scalars['String']>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAndCountBookingsArgs = {
  after?: InputMaybe<Scalars['Date']>;
  before?: InputMaybe<Scalars['Date']>;
  orderBy?: InputMaybe<Array<SortOptions>>;
  shopId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<BookingStatus>>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryGetBoatArgs = {
  id: Scalars['String'];
};


export type QueryGetBoatsArgs = {
  excludeOccupied?: InputMaybe<Scalars['Boolean']>;
  shopId: Scalars['String'];
};


export type QueryGetBoatsWithMetricsArgs = {
  shopId: Scalars['String'];
};


export type QueryGetBookingArgs = {
  id: Scalars['String'];
};


export type QueryGetBookingTriggerArgs = {
  id: Scalars['String'];
};


export type QueryGetBookingTriggersByShopIdArgs = {
  shopId: Scalars['String'];
};


export type QueryGetBookingsArgs = {
  after?: InputMaybe<Scalars['Date']>;
  before?: InputMaybe<Scalars['Date']>;
  orderBy?: InputMaybe<Array<SortOptions>>;
  shopIds?: InputMaybe<Array<Scalars['String']>>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<BookingStatus>>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryGetBookingsByIdArgs = {
  bookingIds: Array<Scalars['String']>;
};


export type QueryGetBookingsByReturnTimeArgs = {
  returnTime: Scalars['Date'];
  shopId: Scalars['String'];
};


export type QueryGetBusinessDayArgs = {
  date: Scalars['Date'];
  shopId: Scalars['String'];
};


export type QueryGetBusinessDaysArgs = {
  after: Scalars['Date'];
  before: Scalars['Date'];
  shopId: Scalars['String'];
};


export type QueryGetBusinessHoursArgs = {
  after?: InputMaybe<Scalars['Date']>;
  before?: InputMaybe<Scalars['Date']>;
  shopId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortOrder>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCancellationPoliciesArgs = {
  shopId: Scalars['String'];
};


export type QueryGetDockingLocationZonesByShopIdArgs = {
  shopId: Scalars['String'];
};


export type QueryGetGiftCardArgs = {
  id: Scalars['String'];
};


export type QueryGetHistoryLogsArgs = {
  id: Scalars['String'];
  relation: HistoryLogRelation;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryGetIntegrationArgs = {
  id: Scalars['String'];
};


export type QueryGetIntegrationProductArgs = {
  id: Scalars['String'];
};


export type QueryGetIntegrationProductsByBookingIdArgs = {
  bookingId: Scalars['String'];
  serviceName: Scalars['String'];
};


export type QueryGetMailchimpConfigArgs = {
  shopId: Scalars['String'];
};


export type QueryGetMembershipArgs = {
  id: Scalars['String'];
};


export type QueryGetPriceModelsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  shopId: Scalars['String'];
};


export type QueryGetReceiptTokenArgs = {
  id: Scalars['String'];
};


export type QueryGetRolesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryGetScheduledTextMessageArgs = {
  id: Scalars['String'];
};


export type QueryGetScheduledTextMessagesArgs = {
  shopId: Scalars['String'];
};


export type QueryGetSendgridEmailArgs = {
  id: Scalars['String'];
};


export type QueryGetSendgridEmailAttachmentArgs = {
  id: Scalars['String'];
};


export type QueryGetSendgridEmailAttachmentsArgs = {
  country: Scalars['String'];
};


export type QueryGetSendgridEmailsArgs = {
  shopId: Scalars['String'];
};


export type QueryGetServiceArgs = {
  id: Scalars['String'];
};


export type QueryGetShopArgs = {
  id: Scalars['String'];
};


export type QueryGetShopConfigurationArgs = {
  shopId: Scalars['String'];
};


export type QueryGetShopsArgs = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
};


export type QueryGetSignedAttachmentUploadLinkArgs = {
  filename: Scalars['String'];
  shopId: Scalars['String'];
};


export type QueryGetTextMessagingSettingsArgs = {
  shopId: Scalars['String'];
};


export type QueryGetTimeslotsArgs = {
  dropoffLocationId?: InputMaybe<Scalars['String']>;
  excludeBookingId?: InputMaybe<Scalars['String']>;
  excludeInvalidSailoutTimes?: InputMaybe<Scalars['Boolean']>;
  excludeReservations?: InputMaybe<Scalars['Boolean']>;
  fromDate: Scalars['Date'];
  integration?: InputMaybe<Scalars['Boolean']>;
  pickupLocationId?: InputMaybe<Scalars['String']>;
  shopId: Scalars['String'];
  toDate: Scalars['Date'];
  useCache?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetUspBannerEntriesArgs = {
  language: SupportedLanguage;
  shopId: Scalars['String'];
};


export type QueryGetVoucherArgs = {
  id: Scalars['String'];
};


export type QueryGetWaiverArgs = {
  id: Scalars['String'];
};


export type QueryGetWaiverBySlugArgs = {
  shopId: Scalars['String'];
  slug: Scalars['String'];
};


export type QueryGetWaiverSubmissionArgs = {
  id: Scalars['String'];
};


export type QueryGetWaiverVersionArgs = {
  id: Scalars['String'];
};


export type QueryGetWaiversArgs = {
  shopId: Scalars['String'];
};


export type QueryPreviewScheduledTextMessageArgs = {
  bookingId: Scalars['String'];
  scheduledTextMessageId: Scalars['String'];
};

export type ReceiptToken = {
  __typename?: 'ReceiptToken';
  entityId: Scalars['String'];
  expires: Scalars['Date'];
  id: Scalars['String'];
  type: ReceiptTokenType;
  userId: Scalars['String'];
};

export enum ReceiptTokenType {
  Booking = 'booking',
  GiftCard = 'giftCard',
  Membership = 'membership'
}

export type Reservation = {
  __typename?: 'Reservation';
  boatCount: Scalars['Int'];
  bookingId: Scalars['String'];
  createdDate: Scalars['Date'];
  date: Scalars['Date'];
  dropoffLocationId?: Maybe<Scalars['String']>;
  duration: Scalars['Float'];
  endTime: Scalars['String'];
  expires: Scalars['Date'];
  id: Scalars['String'];
  itemReservations: Array<ItemReservation>;
  modifiedDate: Scalars['Date'];
  pickupLocationId?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  shopId: Scalars['String'];
  startTime: Scalars['String'];
};

export type Role = {
  __typename?: 'Role';
  id: Scalars['String'];
  name: RoleName;
};

export enum RoleName {
  Admin = 'Admin',
  Crew = 'Crew',
  Reseller = 'Reseller',
  SuperAdmin = 'SuperAdmin',
  System = 'System'
}

export type ScheduledTextMessage = {
  __typename?: 'ScheduledTextMessage';
  body: Scalars['String'];
  bookingConditions: ScheduledTextMessageBookingConditions;
  bookingTriggerIds: Array<Scalars['String']>;
  bookingTriggers: Array<BookingTrigger>;
  enabled: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  shopId: Scalars['String'];
};

export type ScheduledTextMessageBookingConditions = {
  __typename?: 'ScheduledTextMessageBookingConditions';
  canExtend: BooleanCondition;
  languages: Array<SupportedLanguage>;
  missingWaiverSignatures: BooleanCondition;
  resellerBooking: BooleanCondition;
};

export type ScheduledTextMessageBookingConditionsInput = {
  canExtend: BooleanCondition;
  languages: Array<SupportedLanguage>;
  missingWaiverSignatures: BooleanCondition;
  resellerBooking: BooleanCondition;
};

export type ScheduledTextMessageInput = {
  body: Scalars['String'];
  bookingConditions: ScheduledTextMessageBookingConditionsInput;
  bookingTriggerIds: Array<Scalars['String']>;
  enabled: Scalars['Boolean'];
  name: Scalars['String'];
};

export type SendgridEmail = {
  __typename?: 'SendgridEmail';
  attachments: Array<SendgridEmailAttachment>;
  conditions: SendgridEmailConditions;
  enabled: Scalars['Boolean'];
  from: Scalars['String'];
  hasOldAttachments: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  oldAttachments: Array<OldAttachment>;
  options?: Maybe<SendgridEmailOptions>;
  shopId: Scalars['String'];
  templateId: Scalars['String'];
  type: Scalars['String'];
};

export type SendgridEmailAttachment = {
  __typename?: 'SendgridEmailAttachment';
  country: Scalars['String'];
  emails: Array<SendgridEmail>;
  filename: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  path: Scalars['String'];
  personalization?: Maybe<SendgridEmailPersonalizationConfiguration>;
  shopId: Scalars['String'];
  type: Scalars['String'];
};

export type SendgridEmailAttachmentInput = {
  country: Scalars['String'];
  filename: Scalars['String'];
  name: Scalars['String'];
  path: Scalars['String'];
  personalization?: InputMaybe<SendgridEmailPersonalizationConfigurationInput>;
  shopId: Scalars['String'];
  type: Scalars['String'];
};

export type SendgridEmailConditions = {
  __typename?: 'SendgridEmailConditions';
  booking_lang?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Float']>;
  lang?: Maybe<Scalars['String']>;
  plan_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  waiverId?: Maybe<Scalars['String']>;
};

export type SendgridEmailConditionsInput = {
  booking_lang?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Float']>;
  lang?: InputMaybe<Scalars['String']>;
  plan_id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  waiverId?: InputMaybe<Scalars['String']>;
};

export type SendgridEmailInput = {
  conditions: SendgridEmailConditionsInput;
  enabled: Scalars['Boolean'];
  from: Scalars['String'];
  name: Scalars['String'];
  options: SendgridEmailOptionsInput;
  shopId: Scalars['String'];
  templateId: Scalars['String'];
  type: Scalars['String'];
};

export type SendgridEmailOptions = {
  __typename?: 'SendgridEmailOptions';
  emailCopyAddress?: Maybe<Scalars['String']>;
  getEmailCopy?: Maybe<Scalars['Boolean']>;
  receipt?: Maybe<Scalars['Boolean']>;
};

export type SendgridEmailOptionsInput = {
  emailCopyAddress?: InputMaybe<Scalars['String']>;
  getEmailCopy?: InputMaybe<Scalars['Boolean']>;
  receipt?: InputMaybe<Scalars['Boolean']>;
};

export type SendgridEmailPersonalizationConfiguration = {
  __typename?: 'SendgridEmailPersonalizationConfiguration';
  code?: Maybe<AttachmentPersonalization>;
  expires?: Maybe<AttachmentPersonalization>;
  name?: Maybe<AttachmentPersonalization>;
  price?: Maybe<AttachmentPersonalization>;
  shop?: Maybe<AttachmentPersonalization>;
  value?: Maybe<AttachmentPersonalization>;
};

export type SendgridEmailPersonalizationConfigurationInput = {
  code?: InputMaybe<AttachmentPersonalizationInput>;
  expires?: InputMaybe<AttachmentPersonalizationInput>;
  name?: InputMaybe<AttachmentPersonalizationInput>;
  price?: InputMaybe<AttachmentPersonalizationInput>;
  shop?: InputMaybe<AttachmentPersonalizationInput>;
  value?: InputMaybe<AttachmentPersonalizationInput>;
};

export type Service = {
  __typename?: 'Service';
  createdDate?: Maybe<Scalars['Date']>;
  description: Scalars['String'];
  fields: Array<ServiceField>;
  id: Scalars['String'];
  integrations: Array<Integration>;
  modifiedDate?: Maybe<Scalars['Date']>;
  name: Scalars['String'];
  type: ServiceType;
};

export type ServiceField = {
  __typename?: 'ServiceField';
  key: Scalars['String'];
  type: Scalars['String'];
};

export type ServiceFieldInput = {
  key: Scalars['String'];
  type: Scalars['String'];
};

export enum ServiceType {
  Analytics = 'Analytics',
  BoatTracking = 'BoatTracking',
  Emails = 'Emails',
  Newsletter = 'Newsletter',
  Payment = 'Payment',
  Reporting = 'Reporting',
  Reseller = 'Reseller',
  Waivers = 'Waivers'
}

export type Shop = {
  __typename?: 'Shop';
  activeWaivers: Array<Waiver>;
  address: ShopAddress;
  bookingLocalizations?: Maybe<BookingLocalizations>;
  bookingRoot: Scalars['String'];
  cancellationPolicies: Array<CancellationPolicy>;
  configuration?: Maybe<ShopConfiguration>;
  country: Scalars['String'];
  countryCode: Scalars['String'];
  currency: Scalars['String'];
  dockingLocationZones: Array<DockingLocationZone>;
  dockingLocations: Array<DockingLocation>;
  featureFlags: Array<FeatureFlag>;
  giftCardLocalizations?: Maybe<GiftCardLocalizations>;
  hidden?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  integrations: Array<Integration>;
  items: Array<Item>;
  location: Location;
  mailChimpConfig?: Maybe<MailchimpConfig>;
  main?: Maybe<Scalars['Boolean']>;
  maxBoatCount: Scalars['Int'];
  name: Scalars['String'];
  priceModels: Array<PriceModel>;
  scheduledTextMessages: Array<ScheduledTextMessage>;
  sendgridEmails: Array<SendgridEmail>;
  shopSettings?: Maybe<ShopSettings>;
  taxRate: Scalars['Int'];
  textMessagingSettings?: Maybe<TextMessagingSettings>;
  timezoneName: Scalars['String'];
  uspBannerEntries: Array<UspBannerEntry>;
  waivers: Array<Waiver>;
  website: Scalars['String'];
  websiteRoot: Scalars['String'];
};

export type ShopAddress = {
  __typename?: 'ShopAddress';
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  cvr: Scalars['String'];
  format: Scalars['String'];
  recipient: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type ShopConfiguration = {
  __typename?: 'ShopConfiguration';
  enableCustomAmountGiftCards?: Maybe<Scalars['Boolean']>;
  giftcardValidity?: Maybe<Scalars['Int']>;
  gtmId?: Maybe<Scalars['String']>;
  hideGiftCardDurations?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  minimumTimeBetweenBookings?: Maybe<Scalars['Int']>;
  modifiedDate: Scalars['Date'];
  paymentSuccessUrl?: Maybe<Scalars['String']>;
  pixelId?: Maybe<Scalars['String']>;
  preSelectNewsletter?: Maybe<Scalars['Boolean']>;
  refundVoucherValidity?: Maybe<Scalars['Int']>;
  shopId: Scalars['String'];
  stripePublicKey?: Maybe<Scalars['String']>;
  termsUrl?: Maybe<Scalars['String']>;
  waiversWebsite?: Maybe<Scalars['String']>;
};

export type ShopConfigurationInput = {
  enableCustomAmountGiftCards?: InputMaybe<Scalars['Boolean']>;
  giftcardValidity?: InputMaybe<Scalars['Int']>;
  gtmId?: InputMaybe<Scalars['String']>;
  hideGiftCardDurations?: InputMaybe<Scalars['Boolean']>;
  minimumTimeBetweenBookings?: InputMaybe<Scalars['Int']>;
  paymentSuccessUrl?: InputMaybe<Scalars['String']>;
  pixelId?: InputMaybe<Scalars['String']>;
  preSelectNewsletter?: InputMaybe<Scalars['Boolean']>;
  refundVoucherValidity?: InputMaybe<Scalars['Int']>;
  stripePublicKey?: InputMaybe<Scalars['String']>;
  termsUrl?: InputMaybe<Scalars['String']>;
  waiversWebsite?: InputMaybe<Scalars['String']>;
};

export type ShopSettings = {
  __typename?: 'ShopSettings';
  booking: ShopSettingsBooking;
  giftcard?: Maybe<ShopSettingsGiftcard>;
  id: Scalars['String'];
  receipt?: Maybe<ShopSettingsReceipt>;
};

export type ShopSettingsBooking = {
  __typename?: 'ShopSettingsBooking';
  calendarHelpText?: Maybe<ShopSettingsBookingCalendarHelpText>;
  itemsPerPage?: Maybe<Scalars['Int']>;
  newsletterText?: Maybe<ShopSettingsBookingNewsletterText>;
  refundVoucherValidity?: Maybe<Scalars['Int']>;
  termsLink?: Maybe<ShopSettingsBookingTermsLink>;
  termsText?: Maybe<ShopSettingsBookingTermsText>;
};

export type ShopSettingsBookingCalendarHelpText = {
  __typename?: 'ShopSettingsBookingCalendarHelpText';
  da?: Maybe<Scalars['String']>;
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  sv?: Maybe<Scalars['String']>;
};

export type ShopSettingsBookingInput = {
  paymentSuccessShowEmail: Scalars['Boolean'];
  refundVoucherValidity: Scalars['Int'];
};

export type ShopSettingsBookingNewsletterText = {
  __typename?: 'ShopSettingsBookingNewsletterText';
  da?: Maybe<Scalars['String']>;
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  sv?: Maybe<Scalars['String']>;
};

export type ShopSettingsBookingTermsLink = {
  __typename?: 'ShopSettingsBookingTermsLink';
  da?: Maybe<Scalars['String']>;
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  sv?: Maybe<Scalars['String']>;
};

export type ShopSettingsBookingTermsText = {
  __typename?: 'ShopSettingsBookingTermsText';
  da?: Maybe<Scalars['String']>;
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  sv?: Maybe<Scalars['String']>;
};

export type ShopSettingsGiftcard = {
  __typename?: 'ShopSettingsGiftcard';
  faq?: Maybe<Scalars['Boolean']>;
  introText?: Maybe<ShopSettingsGiftcardIntroText>;
  paymentSuccessLink?: Maybe<ShopSettingsGiftcardPaymentSuccessLink>;
  paymentSuccessShowEmail?: Maybe<Scalars['Boolean']>;
  paymentSuccessText?: Maybe<ShopSettingsGiftcardPaymentSuccessText>;
  questions?: Maybe<ShopSettingsGiftcardFaqQuestions>;
  validity?: Maybe<Scalars['Int']>;
};

export type ShopSettingsGiftcardFaqQuestion = {
  __typename?: 'ShopSettingsGiftcardFaqQuestion';
  answer?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
};

export type ShopSettingsGiftcardFaqQuestions = {
  __typename?: 'ShopSettingsGiftcardFaqQuestions';
  da?: Maybe<Array<Maybe<ShopSettingsGiftcardFaqQuestion>>>;
  de?: Maybe<Array<Maybe<ShopSettingsGiftcardFaqQuestion>>>;
  en?: Maybe<Array<Maybe<ShopSettingsGiftcardFaqQuestion>>>;
  sv?: Maybe<Array<Maybe<ShopSettingsGiftcardFaqQuestion>>>;
};

export type ShopSettingsGiftcardIntroText = {
  __typename?: 'ShopSettingsGiftcardIntroText';
  da?: Maybe<Scalars['String']>;
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  sv?: Maybe<Scalars['String']>;
};

export type ShopSettingsGiftcardPaymentSuccessLink = {
  __typename?: 'ShopSettingsGiftcardPaymentSuccessLink';
  da?: Maybe<Scalars['String']>;
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  sv?: Maybe<Scalars['String']>;
};

export type ShopSettingsGiftcardPaymentSuccessText = {
  __typename?: 'ShopSettingsGiftcardPaymentSuccessText';
  da?: Maybe<Scalars['String']>;
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  sv?: Maybe<Scalars['String']>;
};

export type ShopSettingsInput = {
  booking: ShopSettingsBookingInput;
};

export type ShopSettingsReceipt = {
  __typename?: 'ShopSettingsReceipt';
  taxName?: Maybe<ShopSettingsReceiptTaxName>;
  title?: Maybe<ShopSettingsReceiptTitle>;
};

export type ShopSettingsReceiptTaxName = {
  __typename?: 'ShopSettingsReceiptTaxName';
  da?: Maybe<Scalars['String']>;
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  sv?: Maybe<Scalars['String']>;
};

export type ShopSettingsReceiptTitle = {
  __typename?: 'ShopSettingsReceiptTitle';
  da?: Maybe<Scalars['String']>;
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  sv?: Maybe<Scalars['String']>;
};

export type SignatureInput = {
  agreements?: InputMaybe<Array<AgreementInput>>;
  data: WaiverData;
  email?: InputMaybe<Scalars['String']>;
  fullName: Scalars['String'];
  minors?: InputMaybe<Array<MinorSignatureInput>>;
};

export type SignedAttachmentUploadLinkResult = {
  __typename?: 'SignedAttachmentUploadLinkResult';
  filename: Scalars['String'];
  link: Scalars['String'];
};

export type SortOptions = {
  field: Scalars['String'];
  order: SortOrder;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export enum SupportedLanguage {
  Da = 'da',
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  It = 'it',
  Sv = 'sv'
}

export type TextMessage = {
  __typename?: 'TextMessage';
  body: Scalars['String'];
  bookingId: Scalars['String'];
  externalId: Scalars['String'];
  id: Scalars['String'];
  status: TextMessageStatus;
  to: Scalars['String'];
};

export enum TextMessageStatus {
  Accepted = 'accepted',
  Canceled = 'canceled',
  Delivered = 'delivered',
  Failed = 'failed',
  PartiallyDelivered = 'partially_delivered',
  Queued = 'queued',
  Read = 'read',
  Received = 'received',
  Receiving = 'receiving',
  Scheduled = 'scheduled',
  Sending = 'sending',
  Sent = 'sent',
  Undelivered = 'undelivered'
}

export type TextMessagingSettings = {
  __typename?: 'TextMessagingSettings';
  allowCrewCustomMessages: Scalars['Boolean'];
  allowCrewTemplateMessages: Scalars['Boolean'];
  id: Scalars['String'];
  shopId: Scalars['String'];
};

export type TextMessagingSettingsInput = {
  allowCrewCustomMessages: Scalars['Boolean'];
  allowCrewTemplateMessages: Scalars['Boolean'];
};

export type Timeslot = {
  __typename?: 'Timeslot';
  availableToIntegrations: Scalars['Boolean'];
  bookableBoats: Scalars['Int'];
  dateTime: Scalars['Date'];
  isBlockedByMinimumNotice?: Maybe<Scalars['Boolean']>;
  isValidSailoutTime?: Maybe<Scalars['Boolean']>;
  maxConcurrent: Scalars['Int'];
  priceModel: PriceModel;
  priceModelId: Scalars['String'];
  returning: Scalars['Int'];
  sailouts: Scalars['Int'];
  totalSailing: Scalars['Int'];
  vacancies: Array<Vacancy>;
};

export type UpdateBusinessHoursInput = {
  bookableBoats?: InputMaybe<Scalars['Int']>;
  localClosingTime?: InputMaybe<Scalars['String']>;
  localOpeningTime?: InputMaybe<Scalars['String']>;
  maxConcurrent?: InputMaybe<Scalars['Int']>;
  priceModelId?: InputMaybe<Scalars['String']>;
  sailTimes?: InputMaybe<Scalars['Int']>;
};

export type UspBannerEntry = {
  __typename?: 'UspBannerEntry';
  id: Scalars['String'];
  index: Scalars['Int'];
  language: SupportedLanguage;
  modifiedDate: Scalars['String'];
  shopId: Scalars['String'];
  text: Scalars['String'];
};

export type UspBannerInput = {
  index: Scalars['Int'];
  text: Scalars['String'];
};

export type Vacancy = {
  __typename?: 'Vacancy';
  duration: Scalars['DurationString'];
  integrationVacancies: Scalars['Int'];
  price: Scalars['Int'];
  vacancies: Scalars['Int'];
};

export type Voucher = {
  __typename?: 'Voucher';
  category?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdDate?: Maybe<Scalars['Date']>;
  creator?: Maybe<Scalars['String']>;
  days: Array<VoucherDailyValidity>;
  description: Scalars['String'];
  expires: Scalars['Date'];
  id: Scalars['String'];
  maxUsage?: Maybe<Scalars['Boolean']>;
  modifiedDate?: Maybe<Scalars['Date']>;
  shopId: Scalars['String'];
  start?: Maybe<Scalars['Date']>;
  type: VoucherType;
  usageLimit?: Maybe<Scalars['Int']>;
  uses: Scalars['Int'];
  validFor: Array<VoucherValidFor>;
  value: Scalars['Int'];
};

export type VoucherDailyValidity = {
  __typename?: 'VoucherDailyValidity';
  valid: Scalars['Boolean'];
  weekday: CapitalizedWeekday;
};

export enum VoucherType {
  Flat = 'flat',
  Percent = 'percent'
}

export enum VoucherValidFor {
  Booking = 'booking',
  Extras = 'extras',
  Giftcard = 'giftcard',
  Membership = 'membership'
}

export enum VoucherValidityError {
  VoucherAlreadyAdded = 'VoucherAlreadyAdded',
  VoucherDateInvalid = 'VoucherDateInvalid',
  VoucherDepleted = 'VoucherDepleted',
  VoucherInvalid = 'VoucherInvalid',
  VoucherLocationInvalid = 'VoucherLocationInvalid',
  VoucherValidForInvalid = 'VoucherValidForInvalid',
  VoucherWeekdayInvalid = 'VoucherWeekdayInvalid'
}

export type Waiver = {
  __typename?: 'Waiver';
  active: Scalars['Boolean'];
  activeVersions: Array<WaiverVersion>;
  archived: Scalars['Boolean'];
  historyLogs: Array<WaiverHistoryLog>;
  id: Scalars['String'];
  name: Scalars['String'];
  shopId: Scalars['String'];
  slug: Scalars['String'];
  type: WaiverType;
  versions: Array<WaiverVersion>;
};

export type WaiverData = {
  birthDate?: InputMaybe<Scalars['Date']>;
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type WaiverHistoryLog = {
  __typename?: 'WaiverHistoryLog';
  createdDate: Scalars['Date'];
  event: Scalars['String'];
  id: Scalars['String'];
  meta: Scalars['JSON'];
  subjectAdminId?: Maybe<Scalars['String']>;
  waiverId?: Maybe<Scalars['String']>;
  waiverVersionId?: Maybe<Scalars['String']>;
  who?: Maybe<HistoryLogWho>;
};

export type WaiverInput = {
  active: Scalars['Boolean'];
  archived: Scalars['Boolean'];
  name: Scalars['String'];
  shopId: Scalars['String'];
  type: WaiverType;
};

export type WaiverSubmission = {
  __typename?: 'WaiverSubmission';
  agreements: Array<Agreement>;
  birthDate?: Maybe<Scalars['Date']>;
  bookingId: Scalars['String'];
  createdDate: Scalars['Date'];
  email?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  id: Scalars['String'];
  minors: Array<MinorSignature>;
  phone?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  waiver: Waiver;
  waiverId: Scalars['String'];
  waiverVersion: WaiverVersion;
  waiverVersionId: Scalars['String'];
  zip?: Maybe<Scalars['String']>;
};

export enum WaiverType {
  Dock = 'DOCK',
  Online = 'ONLINE'
}

export type WaiverVersion = {
  __typename?: 'WaiverVersion';
  active: Scalars['Boolean'];
  archived: Scalars['Boolean'];
  checkboxes: Array<WaiverVersionCheckbox>;
  confirmationPage: Scalars['String'];
  content: Scalars['String'];
  disableMinorSignatures: Scalars['Boolean'];
  fields: WaiverVersionFields;
  id: Scalars['String'];
  language: Scalars['String'];
  name: Scalars['String'];
  pristine: Scalars['Boolean'];
  requireMinorBirthDate: Scalars['Boolean'];
  sharing: WaiverVersionSharing;
  waiver: Waiver;
  waiverId: Scalars['String'];
};

export type WaiverVersionCheckbox = {
  __typename?: 'WaiverVersionCheckbox';
  name: Scalars['String'];
  omitInPrint: Scalars['Boolean'];
  signature: Scalars['Boolean'];
  text: Scalars['String'];
};

export type WaiverVersionCheckboxInput = {
  name: Scalars['String'];
  omitInPrint: Scalars['Boolean'];
  signature: Scalars['Boolean'];
  text: Scalars['String'];
};

export type WaiverVersionFields = {
  __typename?: 'WaiverVersionFields';
  birthDate: Scalars['Boolean'];
  email: Scalars['Boolean'];
  phone: Scalars['Boolean'];
  state: Scalars['Boolean'];
  zip: Scalars['Boolean'];
};

export type WaiverVersionFieldsInput = {
  birthDate: Scalars['Boolean'];
  email: Scalars['Boolean'];
  phone: Scalars['Boolean'];
  state: Scalars['Boolean'];
  zip: Scalars['Boolean'];
};

export type WaiverVersionInput = {
  checkboxes: Array<WaiverVersionCheckboxInput>;
  confirmationPage: Scalars['String'];
  content: Scalars['String'];
  disableMinorSignatures: Scalars['Boolean'];
  fields: WaiverVersionFieldsInput;
  language: Scalars['String'];
  name: Scalars['String'];
  requireMinorBirthDate: Scalars['Boolean'];
  sharing: WaiverVersionSharingInput;
  waiverId: Scalars['String'];
};

export type WaiverVersionSharing = {
  __typename?: 'WaiverVersionSharing';
  buttonText: Scalars['String'];
  enabled: Scalars['Boolean'];
  heading: Scalars['String'];
  text: Scalars['String'];
};

export type WaiverVersionSharingInput = {
  buttonText: Scalars['String'];
  enabled: Scalars['Boolean'];
  heading: Scalars['String'];
  text: Scalars['String'];
};

export type GetBusinessDaysQueryVariables = Exact<{
  shopId: Scalars['String'];
  after: Scalars['Date'];
  before: Scalars['Date'];
}>;


export type GetBusinessDaysQuery = { __typename?: 'Query', getBusinessDays: Array<{ __typename?: 'BusinessDay', date: string, capacity: number, priceModelId?: string | null, UTCOpeningTime?: string | null, durations: Array<{ __typename?: 'BusinessDayDuration', priceLow: number, priceHigh: number, durationString: any, durationNumber: number }> }> };

export type GetTimeslotsQueryVariables = Exact<{
  shopId: Scalars['String'];
  fromDate: Scalars['Date'];
  toDate: Scalars['Date'];
  excludeBookingId?: InputMaybe<Scalars['String']>;
  pickupLocationId?: InputMaybe<Scalars['String']>;
  dropoffLocationId?: InputMaybe<Scalars['String']>;
}>;


export type GetTimeslotsQuery = { __typename?: 'Query', getTimeslots: Array<{ __typename?: 'Timeslot', dateTime: string, priceModelId: string, isBlockedByMinimumNotice?: boolean | null, vacancies: Array<{ __typename?: 'Vacancy', duration: any, vacancies: number, price: number }> }> };

export type Booking_GetShopQueryVariables = Exact<{
  shopId: Scalars['String'];
}>;


export type Booking_GetShopQuery = { __typename?: 'Query', getShop?: { __typename?: 'Shop', id: string, name: string, currency: string, timezoneName: string, country: string, main?: boolean | null, website: string, hidden?: boolean | null, mailChimpConfig?: { __typename?: 'MailchimpConfig', shopId: string, apiKey: string, defaultListId: string, testListId?: string | null, localizedLists: Array<{ __typename?: 'LocalizedMailChimpList', language: string, id: string }> } | null, shopSettings?: { __typename?: 'ShopSettings', giftcard?: { __typename?: 'ShopSettingsGiftcard', validity?: number | null, faq?: boolean | null, paymentSuccessShowEmail?: boolean | null, introText?: { __typename?: 'ShopSettingsGiftcardIntroText', en?: string | null, da?: string | null, sv?: string | null } | null, questions?: { __typename?: 'ShopSettingsGiftcardFaqQuestions', en?: Array<{ __typename?: 'ShopSettingsGiftcardFaqQuestion', question?: string | null, answer?: string | null } | null> | null, da?: Array<{ __typename?: 'ShopSettingsGiftcardFaqQuestion', question?: string | null, answer?: string | null } | null> | null, sv?: Array<{ __typename?: 'ShopSettingsGiftcardFaqQuestion', question?: string | null, answer?: string | null } | null> | null } | null, paymentSuccessText?: { __typename?: 'ShopSettingsGiftcardPaymentSuccessText', en?: string | null, da?: string | null, sv?: string | null } | null, paymentSuccessLink?: { __typename?: 'ShopSettingsGiftcardPaymentSuccessLink', en?: string | null, da?: string | null, sv?: string | null } | null } | null, booking: { __typename?: 'ShopSettingsBooking', itemsPerPage?: number | null, termsLink?: { __typename?: 'ShopSettingsBookingTermsLink', en?: string | null, da?: string | null, sv?: string | null } | null, termsText?: { __typename?: 'ShopSettingsBookingTermsText', en?: string | null, da?: string | null, sv?: string | null } | null, newsletterText?: { __typename?: 'ShopSettingsBookingNewsletterText', en?: string | null, da?: string | null, sv?: string | null } | null } } | null, configuration?: { __typename?: 'ShopConfiguration', stripePublicKey?: string | null, gtmId?: string | null, pixelId?: string | null, termsUrl?: string | null } | null, cancellationPolicies: Array<{ __typename?: 'CancellationPolicy', name: string, active?: boolean | null, archived?: boolean | null, default: { __typename?: 'CancellationPolicyDetails', location?: number | null, boatCount?: number | null, duration?: number | null, date?: number | null, startTime?: number | null, customerInfo?: number | null, extrasAdd?: number | null, extrasRemove?: number | null, cancel?: number | null, refund?: number | null, voucherRefund?: number | null }, cancellationWarranty?: { __typename?: 'CancellationPolicyDetails', location?: number | null, boatCount?: number | null, duration?: number | null, date?: number | null, startTime?: number | null, customerInfo?: number | null, extrasAdd?: number | null, extrasRemove?: number | null, cancel?: number | null, refund?: number | null, voucherRefund?: number | null } | null, options?: { __typename?: 'CancellationPolicyOptions', warrantyPurchaseCutoff?: number | null, warrantyHelpTextHeading?: Array<{ __typename?: 'CancellationPolicyOptionsWarrantyHelpText', lang?: string | null, value?: string | null } | null> | null, warrantyHelpTextBody?: Array<{ __typename?: 'CancellationPolicyOptionsWarrantyHelpText', lang?: string | null, value?: string | null } | null> | null } | null }>, dockingLocations: Array<{ __typename?: 'DockingLocation', id: string, zoneId: string, name: string, address: string, default: boolean, operations: Array<DockingLocationOperation>, location: { __typename?: 'GPSCoordinates', lat: number, lng: number }, image: { __typename?: 'DockingLocationImage', src: string, alt?: string | null }, priceRange: { __typename?: 'DockingLocationPriceRange', low: number, high: number } }>, priceModels: Array<{ __typename?: 'PriceModel', id: string, name: string, currency: string, defaultDurationBooking?: string | null, defaultDurationGiftcard?: string | null, default: boolean, giftcards?: boolean | null, archived?: boolean | null, shopId?: string | null, createdDate?: string | null, modifiedDate?: string | null, inUse?: boolean | null, durations: Array<{ __typename?: 'PriceModelDuration', duration: any, price: number, giftcards: boolean }>, cancellationWarranty?: { __typename?: 'PriceModelWarranty', per?: string | null, price?: number | null } | null, dockingLocationZonePrices: Array<{ __typename?: 'DockingLocationZonePrice', id: string, dockingLocationZoneId: string, price: number }> }>, items: Array<{ __typename?: 'Item', id: string, name: string, imagepath?: string | null, shortDescription?: string | null, description?: string | null, stock?: number | null, price?: number | null, useCustomPreBookCutoff?: boolean | null, preBookCutoff?: number | null, category?: string | null, displayedOn: Array<string>, preBook?: boolean | null, donation?: boolean | null, archived?: boolean | null, days: Array<{ __typename?: 'ItemDays', weekday?: string | null, available?: boolean | null }>, times?: { __typename?: 'ItemTimes', after?: string | null, before?: string | null } | null, duration?: { __typename?: 'ItemDuration', min?: number | null, max?: number | null } | null }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, featureName: FeatureName, enabled: boolean }> } | null };

export type Booking_GetShopsQueryVariables = Exact<{
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
}>;


export type Booking_GetShopsQuery = { __typename?: 'Query', getShops: Array<{ __typename?: 'Shop', id: string, name: string, currency: string, timezoneName: string, country: string, main?: boolean | null, website: string, hidden?: boolean | null, mailChimpConfig?: { __typename?: 'MailchimpConfig', shopId: string, apiKey: string, defaultListId: string, testListId?: string | null, localizedLists: Array<{ __typename?: 'LocalizedMailChimpList', language: string, id: string }> } | null, shopSettings?: { __typename?: 'ShopSettings', giftcard?: { __typename?: 'ShopSettingsGiftcard', validity?: number | null, faq?: boolean | null, paymentSuccessShowEmail?: boolean | null, introText?: { __typename?: 'ShopSettingsGiftcardIntroText', en?: string | null, da?: string | null, sv?: string | null } | null, questions?: { __typename?: 'ShopSettingsGiftcardFaqQuestions', en?: Array<{ __typename?: 'ShopSettingsGiftcardFaqQuestion', question?: string | null, answer?: string | null } | null> | null, da?: Array<{ __typename?: 'ShopSettingsGiftcardFaqQuestion', question?: string | null, answer?: string | null } | null> | null, sv?: Array<{ __typename?: 'ShopSettingsGiftcardFaqQuestion', question?: string | null, answer?: string | null } | null> | null } | null, paymentSuccessText?: { __typename?: 'ShopSettingsGiftcardPaymentSuccessText', en?: string | null, da?: string | null, sv?: string | null } | null, paymentSuccessLink?: { __typename?: 'ShopSettingsGiftcardPaymentSuccessLink', en?: string | null, da?: string | null, sv?: string | null } | null } | null, booking: { __typename?: 'ShopSettingsBooking', itemsPerPage?: number | null, termsLink?: { __typename?: 'ShopSettingsBookingTermsLink', en?: string | null, da?: string | null, sv?: string | null } | null, termsText?: { __typename?: 'ShopSettingsBookingTermsText', en?: string | null, da?: string | null, sv?: string | null } | null, newsletterText?: { __typename?: 'ShopSettingsBookingNewsletterText', en?: string | null, da?: string | null, sv?: string | null } | null } } | null, configuration?: { __typename?: 'ShopConfiguration', stripePublicKey?: string | null, gtmId?: string | null, pixelId?: string | null, termsUrl?: string | null } | null, cancellationPolicies: Array<{ __typename?: 'CancellationPolicy', name: string, active?: boolean | null, archived?: boolean | null, default: { __typename?: 'CancellationPolicyDetails', location?: number | null, boatCount?: number | null, duration?: number | null, date?: number | null, startTime?: number | null, customerInfo?: number | null, extrasAdd?: number | null, extrasRemove?: number | null, cancel?: number | null, refund?: number | null, voucherRefund?: number | null }, cancellationWarranty?: { __typename?: 'CancellationPolicyDetails', location?: number | null, boatCount?: number | null, duration?: number | null, date?: number | null, startTime?: number | null, customerInfo?: number | null, extrasAdd?: number | null, extrasRemove?: number | null, cancel?: number | null, refund?: number | null, voucherRefund?: number | null } | null, options?: { __typename?: 'CancellationPolicyOptions', warrantyPurchaseCutoff?: number | null, warrantyHelpTextHeading?: Array<{ __typename?: 'CancellationPolicyOptionsWarrantyHelpText', lang?: string | null, value?: string | null } | null> | null, warrantyHelpTextBody?: Array<{ __typename?: 'CancellationPolicyOptionsWarrantyHelpText', lang?: string | null, value?: string | null } | null> | null } | null }>, dockingLocations: Array<{ __typename?: 'DockingLocation', id: string, zoneId: string, name: string, address: string, default: boolean, operations: Array<DockingLocationOperation>, location: { __typename?: 'GPSCoordinates', lat: number, lng: number }, image: { __typename?: 'DockingLocationImage', src: string, alt?: string | null }, priceRange: { __typename?: 'DockingLocationPriceRange', low: number, high: number } }>, priceModels: Array<{ __typename?: 'PriceModel', id: string, name: string, currency: string, defaultDurationBooking?: string | null, defaultDurationGiftcard?: string | null, default: boolean, giftcards?: boolean | null, archived?: boolean | null, shopId?: string | null, createdDate?: string | null, modifiedDate?: string | null, inUse?: boolean | null, durations: Array<{ __typename?: 'PriceModelDuration', duration: any, price: number, giftcards: boolean }>, cancellationWarranty?: { __typename?: 'PriceModelWarranty', per?: string | null, price?: number | null } | null, dockingLocationZonePrices: Array<{ __typename?: 'DockingLocationZonePrice', id: string, dockingLocationZoneId: string, price: number }> }>, items: Array<{ __typename?: 'Item', id: string, name: string, imagepath?: string | null, shortDescription?: string | null, description?: string | null, stock?: number | null, price?: number | null, useCustomPreBookCutoff?: boolean | null, preBookCutoff?: number | null, category?: string | null, displayedOn: Array<string>, preBook?: boolean | null, donation?: boolean | null, archived?: boolean | null, days: Array<{ __typename?: 'ItemDays', weekday?: string | null, available?: boolean | null }>, times?: { __typename?: 'ItemTimes', after?: string | null, before?: string | null } | null, duration?: { __typename?: 'ItemDuration', min?: number | null, max?: number | null } | null }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, featureName: FeatureName, enabled: boolean }> }> };

export type InitiatePaymentCreateBookingMutationVariables = Exact<{
  bookingId: Scalars['String'];
  paymentIntentId: Scalars['String'];
  clientPrice: Scalars['Int'];
  subscribeToNewsletter: Scalars['Boolean'];
}>;


export type InitiatePaymentCreateBookingMutation = { __typename?: 'Mutation', initiatePaymentCreateBooking: { __typename?: 'Booking', id: string, date: string, createdDate: string, modifiedDate?: string | null, startTime: string, endTime: string, reservedTimeslotExpires?: string | null, boatCount: number, price: number, status: BookingStatus, shopId: string, customerId: string, priceModelId?: string | null, cancellationPolicyId?: string | null, duration: number, lang?: SupportedLanguage | null, pickupLocationId?: string | null, dropoffLocationId?: string | null } };

export type EditBookingMutationVariables = Exact<{
  id: Scalars['String'];
  boatCount: Scalars['Int'];
  duration: Scalars['Float'];
  date: Scalars['Date'];
  pickupLocationId?: InputMaybe<Scalars['String']>;
  dropoffLocationId?: InputMaybe<Scalars['String']>;
  forfeitVouchers?: InputMaybe<Scalars['Boolean']>;
}>;


export type EditBookingMutation = { __typename?: 'Mutation', editBooking: { __typename?: 'Booking', id: string, date: string, createdDate: string, modifiedDate?: string | null, startTime: string, endTime: string, reservedTimeslotExpires?: string | null, boatCount: number, price: number, status: BookingStatus, shopId: string, customerId: string, priceModelId?: string | null, cancellationPolicyId?: string | null, duration: number, lang?: SupportedLanguage | null, pickupLocationId?: string | null, dropoffLocationId?: string | null, addons: Array<{ __typename?: 'Addon', id: string, quantity: number, itemId: string }> } };

export type AddCancellationWarrantyMutationVariables = Exact<{
  bookingId: Scalars['String'];
}>;


export type AddCancellationWarrantyMutation = { __typename?: 'Mutation', addCancellationWarranty: { __typename?: 'Booking', id: string, cancellationWarranty?: { __typename?: 'CancellationWarranty', id: string } | null } };

export type UpdatePaymentIntentAmountMutationVariables = Exact<{
  bookingId: Scalars['String'];
  paymentIntentId: Scalars['String'];
  reservationId?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePaymentIntentAmountMutation = { __typename?: 'Mutation', updatePaymentIntentAmount: number };

export type InitiatePaymentEditBookingMutationVariables = Exact<{
  bookingId: Scalars['String'];
  paymentIntentId: Scalars['String'];
  reservationId: Scalars['String'];
  clientPrice: Scalars['Int'];
  subscribeToNewsletter: Scalars['Boolean'];
}>;


export type InitiatePaymentEditBookingMutation = { __typename?: 'Mutation', initiatePaymentEditBooking: { __typename?: 'Booking', id: string, date: string, createdDate: string, modifiedDate?: string | null, startTime: string, endTime: string, reservedTimeslotExpires?: string | null, boatCount: number, price: number, status: BookingStatus, shopId: string, customerId: string, priceModelId?: string | null, cancellationPolicyId?: string | null, duration: number, lang?: SupportedLanguage | null, pickupLocationId?: string | null, dropoffLocationId?: string | null } };

export type InitiatePaymentPayForBookingMutationVariables = Exact<{
  bookingId: Scalars['String'];
  paymentIntentId: Scalars['String'];
  clientPrice: Scalars['Int'];
  subscribeToNewsletter: Scalars['Boolean'];
}>;


export type InitiatePaymentPayForBookingMutation = { __typename?: 'Mutation', initiatePaymentPayForBooking: { __typename?: 'Booking', id: string, date: string, createdDate: string, modifiedDate?: string | null, startTime: string, endTime: string, reservedTimeslotExpires?: string | null, boatCount: number, price: number, status: BookingStatus, shopId: string, customerId: string, priceModelId?: string | null, cancellationPolicyId?: string | null, duration: number, lang?: SupportedLanguage | null, pickupLocationId?: string | null, dropoffLocationId?: string | null } };

export type ReserveTimeslotMutationVariables = Exact<{
  bookingId: Scalars['String'];
  boatCount: Scalars['Int'];
  duration: Scalars['Float'];
  pickupLocationId?: InputMaybe<Scalars['String']>;
  dropoffLocationId?: InputMaybe<Scalars['String']>;
  date: Scalars['Date'];
  items: Array<ItemInput> | ItemInput;
}>;


export type ReserveTimeslotMutation = { __typename?: 'Mutation', reserveTimeslot: { __typename?: 'Reservation', id: string, date: string, duration: number, pickupLocationId?: string | null, dropoffLocationId?: string | null, boatCount: number, expires: string } };

export type CreateReservationPaymentIntentMutationVariables = Exact<{
  reservationId: Scalars['String'];
}>;


export type CreateReservationPaymentIntentMutation = { __typename?: 'Mutation', createReservationPaymentIntent: string };

export type CreatePayForBookingPaymentIntentMutationVariables = Exact<{
  bookingId: Scalars['String'];
}>;


export type CreatePayForBookingPaymentIntentMutation = { __typename?: 'Mutation', createPayForBookingPaymentIntent: string };

export type UpdateCustomerMutationVariables = Exact<{
  id: Scalars['String'];
  input: CustomerInput;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomer: { __typename?: 'Customer', id: string, email?: string | null, firstname?: string | null, lastname?: string | null, phone?: string | null } };

export type ConfirmEditBookingMutationVariables = Exact<{
  reservationId: Scalars['String'];
  subscribeToNewsletter?: InputMaybe<Scalars['Boolean']>;
}>;


export type ConfirmEditBookingMutation = { __typename?: 'Mutation', confirmEditBooking: { __typename?: 'Booking', id: string, date: string, createdDate: string, modifiedDate?: string | null, startTime: string, endTime: string, reservedTimeslotExpires?: string | null, boatCount: number, price: number, status: BookingStatus, shopId: string, customerId: string, priceModelId?: string | null, cancellationPolicyId?: string | null, duration: number, lang?: SupportedLanguage | null, pickupLocationId?: string | null, dropoffLocationId?: string | null } };

export type GetBookingQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetBookingQuery = { __typename?: 'Query', getBooking: { __typename?: 'Booking', refundable: number, id: string, date: string, createdDate: string, modifiedDate?: string | null, startTime: string, endTime: string, reservedTimeslotExpires?: string | null, boatCount: number, price: number, status: BookingStatus, shopId: string, customerId: string, priceModelId?: string | null, cancellationPolicyId?: string | null, duration: number, lang?: SupportedLanguage | null, pickupLocationId?: string | null, dropoffLocationId?: string | null, shop: { __typename?: 'Shop', id: string, name: string, currency: string, timezoneName: string, country: string, main?: boolean | null, website: string, hidden?: boolean | null, mailChimpConfig?: { __typename?: 'MailchimpConfig', shopId: string, apiKey: string, defaultListId: string, testListId?: string | null, localizedLists: Array<{ __typename?: 'LocalizedMailChimpList', language: string, id: string }> } | null, shopSettings?: { __typename?: 'ShopSettings', giftcard?: { __typename?: 'ShopSettingsGiftcard', validity?: number | null, faq?: boolean | null, paymentSuccessShowEmail?: boolean | null, introText?: { __typename?: 'ShopSettingsGiftcardIntroText', en?: string | null, da?: string | null, sv?: string | null } | null, questions?: { __typename?: 'ShopSettingsGiftcardFaqQuestions', en?: Array<{ __typename?: 'ShopSettingsGiftcardFaqQuestion', question?: string | null, answer?: string | null } | null> | null, da?: Array<{ __typename?: 'ShopSettingsGiftcardFaqQuestion', question?: string | null, answer?: string | null } | null> | null, sv?: Array<{ __typename?: 'ShopSettingsGiftcardFaqQuestion', question?: string | null, answer?: string | null } | null> | null } | null, paymentSuccessText?: { __typename?: 'ShopSettingsGiftcardPaymentSuccessText', en?: string | null, da?: string | null, sv?: string | null } | null, paymentSuccessLink?: { __typename?: 'ShopSettingsGiftcardPaymentSuccessLink', en?: string | null, da?: string | null, sv?: string | null } | null } | null, booking: { __typename?: 'ShopSettingsBooking', itemsPerPage?: number | null, termsLink?: { __typename?: 'ShopSettingsBookingTermsLink', en?: string | null, da?: string | null, sv?: string | null } | null, termsText?: { __typename?: 'ShopSettingsBookingTermsText', en?: string | null, da?: string | null, sv?: string | null } | null, newsletterText?: { __typename?: 'ShopSettingsBookingNewsletterText', en?: string | null, da?: string | null, sv?: string | null } | null } } | null, configuration?: { __typename?: 'ShopConfiguration', stripePublicKey?: string | null, gtmId?: string | null, pixelId?: string | null, termsUrl?: string | null } | null, cancellationPolicies: Array<{ __typename?: 'CancellationPolicy', name: string, active?: boolean | null, archived?: boolean | null, default: { __typename?: 'CancellationPolicyDetails', location?: number | null, boatCount?: number | null, duration?: number | null, date?: number | null, startTime?: number | null, customerInfo?: number | null, extrasAdd?: number | null, extrasRemove?: number | null, cancel?: number | null, refund?: number | null, voucherRefund?: number | null }, cancellationWarranty?: { __typename?: 'CancellationPolicyDetails', location?: number | null, boatCount?: number | null, duration?: number | null, date?: number | null, startTime?: number | null, customerInfo?: number | null, extrasAdd?: number | null, extrasRemove?: number | null, cancel?: number | null, refund?: number | null, voucherRefund?: number | null } | null, options?: { __typename?: 'CancellationPolicyOptions', warrantyPurchaseCutoff?: number | null, warrantyHelpTextHeading?: Array<{ __typename?: 'CancellationPolicyOptionsWarrantyHelpText', lang?: string | null, value?: string | null } | null> | null, warrantyHelpTextBody?: Array<{ __typename?: 'CancellationPolicyOptionsWarrantyHelpText', lang?: string | null, value?: string | null } | null> | null } | null }>, dockingLocations: Array<{ __typename?: 'DockingLocation', id: string, zoneId: string, name: string, address: string, default: boolean, operations: Array<DockingLocationOperation>, location: { __typename?: 'GPSCoordinates', lat: number, lng: number }, image: { __typename?: 'DockingLocationImage', src: string, alt?: string | null }, priceRange: { __typename?: 'DockingLocationPriceRange', low: number, high: number } }>, priceModels: Array<{ __typename?: 'PriceModel', id: string, name: string, currency: string, defaultDurationBooking?: string | null, defaultDurationGiftcard?: string | null, default: boolean, giftcards?: boolean | null, archived?: boolean | null, shopId?: string | null, createdDate?: string | null, modifiedDate?: string | null, inUse?: boolean | null, durations: Array<{ __typename?: 'PriceModelDuration', duration: any, price: number, giftcards: boolean }>, cancellationWarranty?: { __typename?: 'PriceModelWarranty', per?: string | null, price?: number | null } | null, dockingLocationZonePrices: Array<{ __typename?: 'DockingLocationZonePrice', id: string, dockingLocationZoneId: string, price: number }> }>, items: Array<{ __typename?: 'Item', id: string, name: string, imagepath?: string | null, shortDescription?: string | null, description?: string | null, stock?: number | null, price?: number | null, useCustomPreBookCutoff?: boolean | null, preBookCutoff?: number | null, category?: string | null, displayedOn: Array<string>, preBook?: boolean | null, donation?: boolean | null, archived?: boolean | null, days: Array<{ __typename?: 'ItemDays', weekday?: string | null, available?: boolean | null }>, times?: { __typename?: 'ItemTimes', after?: string | null, before?: string | null } | null, duration?: { __typename?: 'ItemDuration', min?: number | null, max?: number | null } | null }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, featureName: FeatureName, enabled: boolean }> }, cancellationWarranty?: { __typename?: 'CancellationWarranty', id: string, price: number } | null, addons: Array<{ __typename?: 'Addon', id: string, quantity: number, itemId: string }>, customer: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, id: string }, priceModel: { __typename?: 'PriceModel', name: string, id: string, currency: string, defaultDurationBooking?: string | null, inUse?: boolean | null, durations: Array<{ __typename?: 'PriceModelDuration', duration: any, price: number }>, cancellationWarranty?: { __typename?: 'PriceModelWarranty', per?: string | null, price?: number | null } | null, dockingLocationZonePrices: Array<{ __typename?: 'DockingLocationZonePrice', id: string, dockingLocationZoneId: string, price: number }> }, payments: Array<{ __typename?: 'Payment', id: string, amount: number, currency: string, type: string }>, vouchers: Array<{ __typename?: 'Voucher', type: VoucherType, value: number, description: string, start?: string | null, expires: string, code: string, maxUsage?: boolean | null, usageLimit?: number | null, category?: string | null, validFor: Array<VoucherValidFor>, creator?: string | null, id: string, shopId: string, createdDate?: string | null, modifiedDate?: string | null, days: Array<{ __typename?: 'VoucherDailyValidity', weekday: CapitalizedWeekday, valid: boolean }> }>, reservation?: { __typename?: 'Reservation', id: string } | null } };

export type CancelBookingMutationVariables = Exact<{
  id: Scalars['String'];
  voucherRefund?: InputMaybe<Scalars['Boolean']>;
}>;


export type CancelBookingMutation = { __typename?: 'Mutation', cancelBooking: { __typename?: 'Booking', id: string, status: BookingStatus } };

export type BookingFieldsFragment = { __typename?: 'Booking', id: string, date: string, createdDate: string, modifiedDate?: string | null, startTime: string, endTime: string, reservedTimeslotExpires?: string | null, boatCount: number, price: number, status: BookingStatus, shopId: string, customerId: string, priceModelId?: string | null, cancellationPolicyId?: string | null, duration: number, lang?: SupportedLanguage | null, pickupLocationId?: string | null, dropoffLocationId?: string | null };

export type ExtendedBookingFieldsFragment = { __typename?: 'Booking', cancellationWarranty?: { __typename?: 'CancellationWarranty', id: string, price: number } | null, addons: Array<{ __typename?: 'Addon', id: string, quantity: number, itemId: string }>, customer: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, id: string }, priceModel: { __typename?: 'PriceModel', name: string, id: string, currency: string, defaultDurationBooking?: string | null, inUse?: boolean | null, durations: Array<{ __typename?: 'PriceModelDuration', duration: any, price: number }>, cancellationWarranty?: { __typename?: 'PriceModelWarranty', per?: string | null, price?: number | null } | null, dockingLocationZonePrices: Array<{ __typename?: 'DockingLocationZonePrice', id: string, dockingLocationZoneId: string, price: number }> }, payments: Array<{ __typename?: 'Payment', id: string, amount: number, currency: string, type: string }>, vouchers: Array<{ __typename?: 'Voucher', type: VoucherType, value: number, description: string, start?: string | null, expires: string, code: string, maxUsage?: boolean | null, usageLimit?: number | null, category?: string | null, validFor: Array<VoucherValidFor>, creator?: string | null, id: string, shopId: string, createdDate?: string | null, modifiedDate?: string | null, days: Array<{ __typename?: 'VoucherDailyValidity', weekday: CapitalizedWeekday, valid: boolean }> }>, reservation?: { __typename?: 'Reservation', id: string } | null };

export type ShopFieldsFragment = { __typename?: 'Shop', id: string, name: string, currency: string, timezoneName: string, country: string, main?: boolean | null, website: string, hidden?: boolean | null, mailChimpConfig?: { __typename?: 'MailchimpConfig', shopId: string, apiKey: string, defaultListId: string, testListId?: string | null, localizedLists: Array<{ __typename?: 'LocalizedMailChimpList', language: string, id: string }> } | null, shopSettings?: { __typename?: 'ShopSettings', giftcard?: { __typename?: 'ShopSettingsGiftcard', validity?: number | null, faq?: boolean | null, paymentSuccessShowEmail?: boolean | null, introText?: { __typename?: 'ShopSettingsGiftcardIntroText', en?: string | null, da?: string | null, sv?: string | null } | null, questions?: { __typename?: 'ShopSettingsGiftcardFaqQuestions', en?: Array<{ __typename?: 'ShopSettingsGiftcardFaqQuestion', question?: string | null, answer?: string | null } | null> | null, da?: Array<{ __typename?: 'ShopSettingsGiftcardFaqQuestion', question?: string | null, answer?: string | null } | null> | null, sv?: Array<{ __typename?: 'ShopSettingsGiftcardFaqQuestion', question?: string | null, answer?: string | null } | null> | null } | null, paymentSuccessText?: { __typename?: 'ShopSettingsGiftcardPaymentSuccessText', en?: string | null, da?: string | null, sv?: string | null } | null, paymentSuccessLink?: { __typename?: 'ShopSettingsGiftcardPaymentSuccessLink', en?: string | null, da?: string | null, sv?: string | null } | null } | null, booking: { __typename?: 'ShopSettingsBooking', itemsPerPage?: number | null, termsLink?: { __typename?: 'ShopSettingsBookingTermsLink', en?: string | null, da?: string | null, sv?: string | null } | null, termsText?: { __typename?: 'ShopSettingsBookingTermsText', en?: string | null, da?: string | null, sv?: string | null } | null, newsletterText?: { __typename?: 'ShopSettingsBookingNewsletterText', en?: string | null, da?: string | null, sv?: string | null } | null } } | null, configuration?: { __typename?: 'ShopConfiguration', stripePublicKey?: string | null, gtmId?: string | null, pixelId?: string | null, termsUrl?: string | null } | null, cancellationPolicies: Array<{ __typename?: 'CancellationPolicy', name: string, active?: boolean | null, archived?: boolean | null, default: { __typename?: 'CancellationPolicyDetails', location?: number | null, boatCount?: number | null, duration?: number | null, date?: number | null, startTime?: number | null, customerInfo?: number | null, extrasAdd?: number | null, extrasRemove?: number | null, cancel?: number | null, refund?: number | null, voucherRefund?: number | null }, cancellationWarranty?: { __typename?: 'CancellationPolicyDetails', location?: number | null, boatCount?: number | null, duration?: number | null, date?: number | null, startTime?: number | null, customerInfo?: number | null, extrasAdd?: number | null, extrasRemove?: number | null, cancel?: number | null, refund?: number | null, voucherRefund?: number | null } | null, options?: { __typename?: 'CancellationPolicyOptions', warrantyPurchaseCutoff?: number | null, warrantyHelpTextHeading?: Array<{ __typename?: 'CancellationPolicyOptionsWarrantyHelpText', lang?: string | null, value?: string | null } | null> | null, warrantyHelpTextBody?: Array<{ __typename?: 'CancellationPolicyOptionsWarrantyHelpText', lang?: string | null, value?: string | null } | null> | null } | null }>, dockingLocations: Array<{ __typename?: 'DockingLocation', id: string, zoneId: string, name: string, address: string, default: boolean, operations: Array<DockingLocationOperation>, location: { __typename?: 'GPSCoordinates', lat: number, lng: number }, image: { __typename?: 'DockingLocationImage', src: string, alt?: string | null }, priceRange: { __typename?: 'DockingLocationPriceRange', low: number, high: number } }>, priceModels: Array<{ __typename?: 'PriceModel', id: string, name: string, currency: string, defaultDurationBooking?: string | null, defaultDurationGiftcard?: string | null, default: boolean, giftcards?: boolean | null, archived?: boolean | null, shopId?: string | null, createdDate?: string | null, modifiedDate?: string | null, inUse?: boolean | null, durations: Array<{ __typename?: 'PriceModelDuration', duration: any, price: number, giftcards: boolean }>, cancellationWarranty?: { __typename?: 'PriceModelWarranty', per?: string | null, price?: number | null } | null, dockingLocationZonePrices: Array<{ __typename?: 'DockingLocationZonePrice', id: string, dockingLocationZoneId: string, price: number }> }>, items: Array<{ __typename?: 'Item', id: string, name: string, imagepath?: string | null, shortDescription?: string | null, description?: string | null, stock?: number | null, price?: number | null, useCustomPreBookCutoff?: boolean | null, preBookCutoff?: number | null, category?: string | null, displayedOn: Array<string>, preBook?: boolean | null, donation?: boolean | null, archived?: boolean | null, days: Array<{ __typename?: 'ItemDays', weekday?: string | null, available?: boolean | null }>, times?: { __typename?: 'ItemTimes', after?: string | null, before?: string | null } | null, duration?: { __typename?: 'ItemDuration', min?: number | null, max?: number | null } | null }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, featureName: FeatureName, enabled: boolean }> };

export type LanguagesFragment = { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null };

export type ReserveMutationVariables = Exact<{
  date: Scalars['Date'];
  duration: Scalars['Float'];
  boatCount: Scalars['Int'];
  shopId: Scalars['String'];
  customer: CustomerInput;
  lang: SupportedLanguage;
  pickupLocationId?: InputMaybe<Scalars['String']>;
  dropoffLocationId?: InputMaybe<Scalars['String']>;
}>;


export type ReserveMutation = { __typename?: 'Mutation', reserve: { __typename?: 'Booking', id: string, date: string, createdDate: string, modifiedDate?: string | null, startTime: string, endTime: string, reservedTimeslotExpires?: string | null, boatCount: number, price: number, status: BookingStatus, shopId: string, customerId: string, priceModelId?: string | null, cancellationPolicyId?: string | null, duration: number, lang?: SupportedLanguage | null, pickupLocationId?: string | null, dropoffLocationId?: string | null } };

export type CreateBookingPaymentIntentMutationVariables = Exact<{
  bookingId: Scalars['String'];
}>;


export type CreateBookingPaymentIntentMutation = { __typename?: 'Mutation', createBookingPaymentIntent: string };

export type ConfirmBookingMutationVariables = Exact<{
  bookingId: Scalars['String'];
  subToNewsletter?: InputMaybe<Scalars['Boolean']>;
}>;


export type ConfirmBookingMutation = { __typename?: 'Mutation', customerConfirmBooking: { __typename?: 'Booking', id: string, date: string, createdDate: string, modifiedDate?: string | null, startTime: string, endTime: string, reservedTimeslotExpires?: string | null, boatCount: number, price: number, status: BookingStatus, shopId: string, customerId: string, priceModelId?: string | null, cancellationPolicyId?: string | null, duration: number, lang?: SupportedLanguage | null, pickupLocationId?: string | null, dropoffLocationId?: string | null } };

export type SetBookingAddonsMutationVariables = Exact<{
  bookingId: Scalars['String'];
  items: Array<ItemInput> | ItemInput;
}>;


export type SetBookingAddonsMutation = { __typename?: 'Mutation', setBookingAddons: { __typename?: 'Booking', id: string, addons: Array<{ __typename?: 'Addon', quantity: number, itemId: string }> } };

export type SetReservtionItemsMutationVariables = Exact<{
  reservationId: Scalars['String'];
  items: Array<ItemInput> | ItemInput;
}>;


export type SetReservtionItemsMutation = { __typename?: 'Mutation', setReservationItems: Array<{ __typename?: 'ItemReservation', id: string, quantity: number, itemId: string }> };

export type RemoveCancellationWarrantyMutationVariables = Exact<{
  bookingId: Scalars['String'];
}>;


export type RemoveCancellationWarrantyMutation = { __typename?: 'Mutation', removeCancellationWarranty: { __typename?: 'Booking', id: string, cancellationWarranty?: { __typename?: 'CancellationWarranty', id: string } | null } };

export type ApplyVoucherToBookingMutationVariables = Exact<{
  bookingId: Scalars['String'];
  voucherCode: Scalars['String'];
  paymentIntentId?: InputMaybe<Scalars['String']>;
  reservationId?: InputMaybe<Scalars['String']>;
}>;


export type ApplyVoucherToBookingMutation = { __typename?: 'Mutation', applyVoucherToBooking: { __typename?: 'Booking', id: string, date: string, createdDate: string, modifiedDate?: string | null, startTime: string, endTime: string, reservedTimeslotExpires?: string | null, boatCount: number, price: number, status: BookingStatus, shopId: string, customerId: string, priceModelId?: string | null, cancellationPolicyId?: string | null, duration: number, lang?: SupportedLanguage | null, pickupLocationId?: string | null, dropoffLocationId?: string | null, cancellationWarranty?: { __typename?: 'CancellationWarranty', id: string, price: number } | null, addons: Array<{ __typename?: 'Addon', id: string, quantity: number, itemId: string }>, customer: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, id: string }, priceModel: { __typename?: 'PriceModel', name: string, id: string, currency: string, defaultDurationBooking?: string | null, inUse?: boolean | null, durations: Array<{ __typename?: 'PriceModelDuration', duration: any, price: number }>, cancellationWarranty?: { __typename?: 'PriceModelWarranty', per?: string | null, price?: number | null } | null, dockingLocationZonePrices: Array<{ __typename?: 'DockingLocationZonePrice', id: string, dockingLocationZoneId: string, price: number }> }, payments: Array<{ __typename?: 'Payment', id: string, amount: number, currency: string, type: string }>, vouchers: Array<{ __typename?: 'Voucher', type: VoucherType, value: number, description: string, start?: string | null, expires: string, code: string, maxUsage?: boolean | null, usageLimit?: number | null, category?: string | null, validFor: Array<VoucherValidFor>, creator?: string | null, id: string, shopId: string, createdDate?: string | null, modifiedDate?: string | null, days: Array<{ __typename?: 'VoucherDailyValidity', weekday: CapitalizedWeekday, valid: boolean }> }>, reservation?: { __typename?: 'Reservation', id: string } | null } };

export type GetShopQueryVariables = Exact<{
  shopId: Scalars['String'];
}>;


export type GetShopQuery = { __typename?: 'Query', getShop?: { __typename?: 'Shop', id: string, name: string, maxBoatCount: number, main?: boolean | null, configuration?: { __typename?: 'ShopConfiguration', gtmId?: string | null, pixelId?: string | null, stripePublicKey?: string | null, termsUrl?: string | null, paymentSuccessUrl?: string | null, preSelectNewsletter?: boolean | null, enableCustomAmountGiftCards?: boolean | null, hideGiftCardDurations?: boolean | null, refundVoucherValidity?: number | null } | null, bookingLocalizations?: { __typename?: 'BookingLocalizations', calendarHelpText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, newsletterText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, lastStepInfo?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, termsLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, termsText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, warrantyLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null } | null, giftCardLocalizations?: { __typename?: 'GiftCardLocalizations', heading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, instructions?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, stepOneHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, stepTwoHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, stepThreeHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, newsletterText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null } | null } | null };

export type GetUspBannerEntriesQueryVariables = Exact<{
  shopId: Scalars['String'];
  language: SupportedLanguage;
}>;


export type GetUspBannerEntriesQuery = { __typename?: 'Query', getUspBannerEntries: Array<{ __typename?: 'UspBannerEntry', id: string, index: number, text: string, shopId: string }> };

export const BookingFieldsFragmentDoc = gql`
    fragment BookingFields on Booking {
  id
  date
  createdDate
  modifiedDate
  startTime
  endTime
  reservedTimeslotExpires
  boatCount
  price
  status
  shopId
  customerId
  priceModelId
  cancellationPolicyId
  duration
  lang
  pickupLocationId
  dropoffLocationId
}
    `;
export const ExtendedBookingFieldsFragmentDoc = gql`
    fragment ExtendedBookingFields on Booking {
  cancellationWarranty {
    id
    price
  }
  addons {
    id
    quantity
    itemId
  }
  customer {
    firstname
    lastname
    email
    phone
    id
  }
  priceModel {
    name
    id
    currency
    durations {
      duration
      price
    }
    defaultDurationBooking
    inUse
    cancellationWarranty {
      per
      price
    }
    dockingLocationZonePrices {
      id
      dockingLocationZoneId
      price
    }
  }
  payments {
    id
    amount
    currency
    type
  }
  vouchers {
    type
    value
    description
    start
    expires
    code
    maxUsage
    usageLimit
    category
    validFor
    creator
    id
    shopId
    createdDate
    modifiedDate
    days {
      weekday
      valid
    }
  }
  reservation {
    id
  }
}
    `;
export const ShopFieldsFragmentDoc = gql`
    fragment ShopFields on Shop {
  id
  name
  currency
  timezoneName
  country
  main
  website
  hidden
  mailChimpConfig {
    shopId
    apiKey
    defaultListId
    testListId
    localizedLists {
      language
      id
    }
  }
  shopSettings {
    giftcard {
      validity
      introText {
        en
        da
        sv
      }
      faq
      questions {
        en {
          question
          answer
        }
        da {
          question
          answer
        }
        sv {
          question
          answer
        }
      }
      paymentSuccessText {
        en
        da
        sv
      }
      paymentSuccessLink {
        en
        da
        sv
      }
      paymentSuccessShowEmail
    }
    booking {
      itemsPerPage
      termsLink {
        en
        da
        sv
      }
      termsText {
        en
        da
        sv
      }
      newsletterText {
        en
        da
        sv
      }
    }
  }
  configuration {
    stripePublicKey
    gtmId
    pixelId
    termsUrl
  }
  cancellationPolicies {
    name
    active
    archived
    default {
      location
      boatCount
      duration
      date
      startTime
      customerInfo
      extrasAdd
      extrasRemove
      cancel
      refund
      voucherRefund
    }
    cancellationWarranty {
      location
      boatCount
      duration
      date
      startTime
      customerInfo
      extrasAdd
      extrasRemove
      cancel
      refund
      voucherRefund
    }
    options {
      warrantyHelpTextHeading {
        lang
        value
      }
      warrantyHelpTextBody {
        lang
        value
      }
      warrantyPurchaseCutoff
    }
  }
  dockingLocations {
    id
    zoneId
    name
    address
    default
    operations
    location {
      lat
      lng
    }
    image {
      src
      alt
    }
    priceRange {
      low
      high
    }
  }
  priceModels {
    id
    name
    currency
    durations {
      duration
      price
      giftcards
    }
    defaultDurationBooking
    defaultDurationGiftcard
    cancellationWarranty {
      per
      price
    }
    default
    giftcards
    archived
    shopId
    createdDate
    modifiedDate
    inUse
    dockingLocationZonePrices {
      id
      dockingLocationZoneId
      price
    }
  }
  items {
    id
    name
    imagepath
    shortDescription
    description
    stock
    price
    useCustomPreBookCutoff
    preBookCutoff
    category
    displayedOn
    preBook
    days {
      weekday
      available
    }
    times {
      after
      before
    }
    duration {
      min
      max
    }
    donation
    archived
  }
  featureFlags {
    id
    featureName
    enabled
  }
}
    `;
export const LanguagesFragmentDoc = gql`
    fragment Languages on Localization {
  da
  en
  sv
  de
  es
  fr
  it
}
    `;
export const GetBusinessDaysDocument = gql`
    query getBusinessDays($shopId: String!, $after: Date!, $before: Date!) {
  getBusinessDays(shopId: $shopId, after: $after, before: $before) {
    date
    capacity
    priceModelId
    UTCOpeningTime
    durations {
      priceLow
      priceHigh
      durationString
      durationNumber
    }
  }
}
    `;
export const GetTimeslotsDocument = gql`
    query getTimeslots($shopId: String!, $fromDate: Date!, $toDate: Date!, $excludeBookingId: String, $pickupLocationId: String, $dropoffLocationId: String) {
  getTimeslots(
    shopId: $shopId
    fromDate: $fromDate
    toDate: $toDate
    excludeBookingId: $excludeBookingId
    excludeInvalidSailoutTimes: true
    pickupLocationId: $pickupLocationId
    dropoffLocationId: $dropoffLocationId
  ) {
    dateTime
    priceModelId
    isBlockedByMinimumNotice
    vacancies {
      duration
      vacancies
      price
    }
  }
}
    `;
export const Booking_GetShopDocument = gql`
    query booking_getShop($shopId: String!) {
  getShop(id: $shopId) {
    ...ShopFields
  }
}
    ${ShopFieldsFragmentDoc}`;
export const Booking_GetShopsDocument = gql`
    query booking_getShops($city: String, $country: String) {
  getShops(city: $city, country: $country) {
    ...ShopFields
  }
}
    ${ShopFieldsFragmentDoc}`;
export const InitiatePaymentCreateBookingDocument = gql`
    mutation initiatePaymentCreateBooking($bookingId: String!, $paymentIntentId: String!, $clientPrice: Int!, $subscribeToNewsletter: Boolean!) {
  initiatePaymentCreateBooking(
    bookingId: $bookingId
    paymentIntentId: $paymentIntentId
    clientPrice: $clientPrice
    subscribeToNewsletter: $subscribeToNewsletter
  ) {
    ...BookingFields
  }
}
    ${BookingFieldsFragmentDoc}`;
export const EditBookingDocument = gql`
    mutation editBooking($id: String!, $boatCount: Int!, $duration: Float!, $date: Date!, $pickupLocationId: String, $dropoffLocationId: String, $forfeitVouchers: Boolean) {
  editBooking(
    id: $id
    boatCount: $boatCount
    duration: $duration
    date: $date
    pickupLocationId: $pickupLocationId
    dropoffLocationId: $dropoffLocationId
    forfeitVouchers: $forfeitVouchers
  ) {
    ...BookingFields
    addons {
      id
      quantity
      itemId
    }
  }
}
    ${BookingFieldsFragmentDoc}`;
export const AddCancellationWarrantyDocument = gql`
    mutation addCancellationWarranty($bookingId: String!) {
  addCancellationWarranty(bookingId: $bookingId) {
    id
    cancellationWarranty {
      id
    }
  }
}
    `;
export const UpdatePaymentIntentAmountDocument = gql`
    mutation updatePaymentIntentAmount($bookingId: String!, $paymentIntentId: String!, $reservationId: String) {
  updatePaymentIntentAmount(
    bookingId: $bookingId
    paymentIntentId: $paymentIntentId
    reservationId: $reservationId
  )
}
    `;
export const InitiatePaymentEditBookingDocument = gql`
    mutation initiatePaymentEditBooking($bookingId: String!, $paymentIntentId: String!, $reservationId: String!, $clientPrice: Int!, $subscribeToNewsletter: Boolean!) {
  initiatePaymentEditBooking(
    bookingId: $bookingId
    paymentIntentId: $paymentIntentId
    reservationId: $reservationId
    clientPrice: $clientPrice
    subscribeToNewsletter: $subscribeToNewsletter
  ) {
    ...BookingFields
  }
}
    ${BookingFieldsFragmentDoc}`;
export const InitiatePaymentPayForBookingDocument = gql`
    mutation initiatePaymentPayForBooking($bookingId: String!, $paymentIntentId: String!, $clientPrice: Int!, $subscribeToNewsletter: Boolean!) {
  initiatePaymentPayForBooking(
    bookingId: $bookingId
    paymentIntentId: $paymentIntentId
    clientPrice: $clientPrice
    subscribeToNewsletter: $subscribeToNewsletter
  ) {
    ...BookingFields
  }
}
    ${BookingFieldsFragmentDoc}`;
export const ReserveTimeslotDocument = gql`
    mutation reserveTimeslot($bookingId: String!, $boatCount: Int!, $duration: Float!, $pickupLocationId: String, $dropoffLocationId: String, $date: Date!, $items: [ItemInput!]!) {
  reserveTimeslot(
    bookingId: $bookingId
    boatCount: $boatCount
    duration: $duration
    pickupLocationId: $pickupLocationId
    dropoffLocationId: $dropoffLocationId
    date: $date
    items: $items
  ) {
    id
    date
    duration
    pickupLocationId
    dropoffLocationId
    boatCount
    expires
  }
}
    `;
export const CreateReservationPaymentIntentDocument = gql`
    mutation createReservationPaymentIntent($reservationId: String!) {
  createReservationPaymentIntent(reservationId: $reservationId)
}
    `;
export const CreatePayForBookingPaymentIntentDocument = gql`
    mutation createPayForBookingPaymentIntent($bookingId: String!) {
  createPayForBookingPaymentIntent(bookingId: $bookingId)
}
    `;
export const UpdateCustomerDocument = gql`
    mutation updateCustomer($id: String!, $input: CustomerInput!) {
  updateCustomer(id: $id, input: $input) {
    id
    email
    firstname
    lastname
    phone
  }
}
    `;
export const ConfirmEditBookingDocument = gql`
    mutation confirmEditBooking($reservationId: String!, $subscribeToNewsletter: Boolean) {
  confirmEditBooking(
    reservationId: $reservationId
    subToNewsletter: $subscribeToNewsletter
  ) {
    ...BookingFields
  }
}
    ${BookingFieldsFragmentDoc}`;
export const GetBookingDocument = gql`
    query getBooking($id: String!) {
  getBooking(id: $id) {
    ...BookingFields
    ...ExtendedBookingFields
    refundable
    shop {
      ...ShopFields
    }
  }
}
    ${BookingFieldsFragmentDoc}
${ExtendedBookingFieldsFragmentDoc}
${ShopFieldsFragmentDoc}`;
export const CancelBookingDocument = gql`
    mutation cancelBooking($id: String!, $voucherRefund: Boolean) {
  cancelBooking(id: $id, voucherRefund: $voucherRefund) {
    id
    status
  }
}
    `;
export const ReserveDocument = gql`
    mutation reserve($date: Date!, $duration: Float!, $boatCount: Int!, $shopId: String!, $customer: CustomerInput!, $lang: SupportedLanguage!, $pickupLocationId: String, $dropoffLocationId: String) {
  reserve(
    date: $date
    duration: $duration
    boatCount: $boatCount
    shopId: $shopId
    customer: $customer
    lang: $lang
    pickupLocationId: $pickupLocationId
    dropoffLocationId: $dropoffLocationId
  ) {
    ...BookingFields
  }
}
    ${BookingFieldsFragmentDoc}`;
export const CreateBookingPaymentIntentDocument = gql`
    mutation createBookingPaymentIntent($bookingId: String!) {
  createBookingPaymentIntent(id: $bookingId)
}
    `;
export const ConfirmBookingDocument = gql`
    mutation confirmBooking($bookingId: String!, $subToNewsletter: Boolean) {
  customerConfirmBooking(bookingId: $bookingId, subToNewsletter: $subToNewsletter) {
    ...BookingFields
  }
}
    ${BookingFieldsFragmentDoc}`;
export const SetBookingAddonsDocument = gql`
    mutation setBookingAddons($bookingId: String!, $items: [ItemInput!]!) {
  setBookingAddons(bookingId: $bookingId, items: $items) {
    id
    addons {
      quantity
      itemId
    }
  }
}
    `;
export const SetReservtionItemsDocument = gql`
    mutation setReservtionItems($reservationId: String!, $items: [ItemInput!]!) {
  setReservationItems(reservationId: $reservationId, items: $items) {
    id
    quantity
    itemId
  }
}
    `;
export const RemoveCancellationWarrantyDocument = gql`
    mutation removeCancellationWarranty($bookingId: String!) {
  removeCancellationWarranty(bookingId: $bookingId) {
    id
    cancellationWarranty {
      id
    }
  }
}
    `;
export const ApplyVoucherToBookingDocument = gql`
    mutation applyVoucherToBooking($bookingId: String!, $voucherCode: String!, $paymentIntentId: String, $reservationId: String) {
  applyVoucherToBooking(
    bookingId: $bookingId
    voucherCode: $voucherCode
    paymentIntentId: $paymentIntentId
    reservationId: $reservationId
  ) {
    ...BookingFields
    ...ExtendedBookingFields
  }
}
    ${BookingFieldsFragmentDoc}
${ExtendedBookingFieldsFragmentDoc}`;
export const GetShopDocument = gql`
    query getShop($shopId: String!) {
  getShop(id: $shopId) {
    id
    name
    maxBoatCount
    main
    configuration {
      gtmId
      pixelId
      stripePublicKey
      termsUrl
      paymentSuccessUrl
      preSelectNewsletter
      enableCustomAmountGiftCards
      hideGiftCardDurations
      refundVoucherValidity
    }
    bookingLocalizations {
      calendarHelpText {
        ...Languages
      }
      paymentSuccessLink {
        ...Languages
      }
      newsletterText {
        ...Languages
      }
      lastStepInfo {
        ...Languages
      }
      paymentSuccessText {
        ...Languages
      }
      termsLink {
        ...Languages
      }
      termsText {
        ...Languages
      }
      warrantyLink {
        ...Languages
      }
    }
    giftCardLocalizations {
      heading {
        ...Languages
      }
      instructions {
        ...Languages
      }
      stepOneHeading {
        ...Languages
      }
      stepTwoHeading {
        ...Languages
      }
      stepThreeHeading {
        ...Languages
      }
      newsletterText {
        ...Languages
      }
    }
  }
}
    ${LanguagesFragmentDoc}`;
export const GetUspBannerEntriesDocument = gql`
    query getUspBannerEntries($shopId: String!, $language: SupportedLanguage!) {
  getUspBannerEntries(shopId: $shopId, language: $language) {
    id
    index
    text
    shopId
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    getBusinessDays(variables: GetBusinessDaysQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetBusinessDaysQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBusinessDaysQuery>(GetBusinessDaysDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBusinessDays', 'query');
    },
    getTimeslots(variables: GetTimeslotsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetTimeslotsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTimeslotsQuery>(GetTimeslotsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getTimeslots', 'query');
    },
    booking_getShop(variables: Booking_GetShopQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<Booking_GetShopQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Booking_GetShopQuery>(Booking_GetShopDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'booking_getShop', 'query');
    },
    booking_getShops(variables?: Booking_GetShopsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<Booking_GetShopsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Booking_GetShopsQuery>(Booking_GetShopsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'booking_getShops', 'query');
    },
    initiatePaymentCreateBooking(variables: InitiatePaymentCreateBookingMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<InitiatePaymentCreateBookingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InitiatePaymentCreateBookingMutation>(InitiatePaymentCreateBookingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'initiatePaymentCreateBooking', 'mutation');
    },
    editBooking(variables: EditBookingMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<EditBookingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditBookingMutation>(EditBookingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'editBooking', 'mutation');
    },
    addCancellationWarranty(variables: AddCancellationWarrantyMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddCancellationWarrantyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddCancellationWarrantyMutation>(AddCancellationWarrantyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addCancellationWarranty', 'mutation');
    },
    updatePaymentIntentAmount(variables: UpdatePaymentIntentAmountMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdatePaymentIntentAmountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePaymentIntentAmountMutation>(UpdatePaymentIntentAmountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePaymentIntentAmount', 'mutation');
    },
    initiatePaymentEditBooking(variables: InitiatePaymentEditBookingMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<InitiatePaymentEditBookingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InitiatePaymentEditBookingMutation>(InitiatePaymentEditBookingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'initiatePaymentEditBooking', 'mutation');
    },
    initiatePaymentPayForBooking(variables: InitiatePaymentPayForBookingMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<InitiatePaymentPayForBookingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InitiatePaymentPayForBookingMutation>(InitiatePaymentPayForBookingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'initiatePaymentPayForBooking', 'mutation');
    },
    reserveTimeslot(variables: ReserveTimeslotMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ReserveTimeslotMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReserveTimeslotMutation>(ReserveTimeslotDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'reserveTimeslot', 'mutation');
    },
    createReservationPaymentIntent(variables: CreateReservationPaymentIntentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateReservationPaymentIntentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateReservationPaymentIntentMutation>(CreateReservationPaymentIntentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createReservationPaymentIntent', 'mutation');
    },
    createPayForBookingPaymentIntent(variables: CreatePayForBookingPaymentIntentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreatePayForBookingPaymentIntentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePayForBookingPaymentIntentMutation>(CreatePayForBookingPaymentIntentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createPayForBookingPaymentIntent', 'mutation');
    },
    updateCustomer(variables: UpdateCustomerMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateCustomerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCustomerMutation>(UpdateCustomerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCustomer', 'mutation');
    },
    confirmEditBooking(variables: ConfirmEditBookingMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ConfirmEditBookingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConfirmEditBookingMutation>(ConfirmEditBookingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'confirmEditBooking', 'mutation');
    },
    getBooking(variables: GetBookingQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetBookingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBookingQuery>(GetBookingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBooking', 'query');
    },
    cancelBooking(variables: CancelBookingMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CancelBookingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CancelBookingMutation>(CancelBookingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'cancelBooking', 'mutation');
    },
    reserve(variables: ReserveMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ReserveMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReserveMutation>(ReserveDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'reserve', 'mutation');
    },
    createBookingPaymentIntent(variables: CreateBookingPaymentIntentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateBookingPaymentIntentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateBookingPaymentIntentMutation>(CreateBookingPaymentIntentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createBookingPaymentIntent', 'mutation');
    },
    confirmBooking(variables: ConfirmBookingMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ConfirmBookingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConfirmBookingMutation>(ConfirmBookingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'confirmBooking', 'mutation');
    },
    setBookingAddons(variables: SetBookingAddonsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SetBookingAddonsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetBookingAddonsMutation>(SetBookingAddonsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setBookingAddons', 'mutation');
    },
    setReservtionItems(variables: SetReservtionItemsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SetReservtionItemsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetReservtionItemsMutation>(SetReservtionItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setReservtionItems', 'mutation');
    },
    removeCancellationWarranty(variables: RemoveCancellationWarrantyMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RemoveCancellationWarrantyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveCancellationWarrantyMutation>(RemoveCancellationWarrantyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeCancellationWarranty', 'mutation');
    },
    applyVoucherToBooking(variables: ApplyVoucherToBookingMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ApplyVoucherToBookingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApplyVoucherToBookingMutation>(ApplyVoucherToBookingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'applyVoucherToBooking', 'mutation');
    },
    getShop(variables: GetShopQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetShopQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetShopQuery>(GetShopDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getShop', 'query');
    },
    getUspBannerEntries(variables: GetUspBannerEntriesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUspBannerEntriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUspBannerEntriesQuery>(GetUspBannerEntriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUspBannerEntries', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;